/**
 * HALFPE — VIJAYAWADA RETAIL EXPO CENTRAL BILLING & PAYMENT TERMINAL
 * Client-Side Multi-Vendor Billing Controller & POS Engine
 * Based on Half Price Days Developer Requirements Spec (Oct 1, 2026)
 */

(function () {
  'use strict';

  var URL_PARAMS = new URLSearchParams(window.location.search);
  var rawCity = (URL_PARAMS.get('city') || URL_PARAMS.get('cityId') || 'VIJ').toUpperCase();
  if (rawCity === 'VIJAYAWADA') rawCity = 'VIJ';
  if (rawCity === 'HYDERABAD') rawCity = 'HYD';
  if (rawCity === 'VISAKHAPATNAM' || rawCity === 'VIZAG') rawCity = 'VSP';
  if (rawCity === 'BENGALURU' || rawCity === 'BANGALORE') rawCity = 'BLR';
  var CURRENT_CITY_ID = rawCity;
  var IS_VIJ = CURRENT_CITY_ID === 'VIJ';
  var CITY_LABEL = { VIJ: 'Vijayawada', HYD: 'Hyderabad', VSP: 'Visakhapatnam', BLR: 'Bengaluru' }[CURRENT_CITY_ID] || CURRENT_CITY_ID;
  // Venue of the city this page is billing for, filled from the dashboard (non-VIJ pages)
  var CITY_INFO = null;
  var DASHBOARD_API = 'https://halfpe-settlement-dashboard-production.up.railway.app';

  // =========================================================================
  // 1. STALL MASTER DATA & DYNAMIC MAPPING
  // =========================================================================
  var VIJAYAWADA_STALL_MASTER = [
  {
    "stallNo": "01",
    "vendorName": "Profit Shoe Company",
    "vendorCode": "PSC",
    "category": "footwear"
  },
  {
    "stallNo": "02, 11, 12, 23, 40, 57 & 60",
    "vendorName": "Half Price Days Event",
    "vendorCode": "HPDALL",
    "category": "misc"
  },
  {
    "stallNo": "03",
    "vendorName": "9 to 9 dollar shop",
    "vendorCode": "NDS",
    "category": "gifts and home decor"
  },
  {
    "stallNo": "04",
    "vendorName": "Sri kleemkara creations",
    "vendorCode": "SKC",
    "category": "clothing"
  },
  {
    "stallNo": "06 & 07",
    "vendorName": "D TOWN",
    "vendorCode": "DTS",
    "category": "textiles"
  },
  {
    "stallNo": "08",
    "vendorName": "Al Zahra Perfumes",
    "vendorCode": "AZP",
    "category": "perfumes"
  },
  {
    "stallNo": "09",
    "vendorName": "Aavasa and jyothy cotton",
    "vendorCode": "AJC",
    "category": "sarees & frocks"
  },
  {
    "stallNo": "14 & 15",
    "vendorName": "A Shaw Collection (W.B)",
    "vendorCode": "SCW",
    "category": "jamdani sarees & dress"
  },
  {
    "stallNo": "16",
    "vendorName": "G.K.Fashions - Vijayawada",
    "vendorCode": "GKF",
    "category": "women clothing"
  },
  {
    "stallNo": "17",
    "vendorName": "Alaka Fashions",
    "vendorCode": "ALF",
    "category": "1 gram jewellery"
  },
  {
    "stallNo": "18 & 19",
    "vendorName": "K.K.APPLIANCES",
    "vendorCode": "KKA",
    "category": "kitchenware, appliances, giftware, stablizers"
  },
  {
    "stallNo": "20",
    "vendorName": "CHANDRA ELECTRONICS & HOME APPLIANCES",
    "vendorCode": "CHA",
    "category": "electronics & home appliances"
  },
  {
    "stallNo": "21",
    "vendorName": "Gallant",
    "vendorCode": "GAL",
    "category": "kids wear"
  },
  {
    "stallNo": "22",
    "vendorName": "Kolus Home",
    "vendorCode": "KLH",
    "category": "home decor and wellness products"
  },
  {
    "stallNo": "24",
    "vendorName": "Rajasyamala enterprises",
    "vendorCode": "RSE",
    "category": "sarees"
  },
  {
    "stallNo": "25",
    "vendorName": "Varaahi (T Devika)",
    "vendorCode": "VTD",
    "category": "sarees"
  },
  {
    "stallNo": "26",
    "vendorName": "Sathyam Silks (VIJ EVENT)",
    "vendorCode": "SSM",
    "category": "sarees"
  },
  {
    "stallNo": "29",
    "vendorName": "SV Customised Charms",
    "vendorCode": "SVCC",
    "category": "customised gifts & charms"
  },
  {
    "stallNo": "30",
    "vendorName": "S&K Clothing Co.",
    "vendorCode": "SKC",
    "category": "clothing"
  },
  {
    "stallNo": "34 & 35",
    "vendorName": "Siva Naga jewellery",
    "vendorCode": "SNJ",
    "category": "jewellery"
  },
  {
    "stallNo": "36",
    "vendorName": "Click2magnet",
    "vendorCode": "CTM",
    "category": "misc."
  },
  {
    "stallNo": "37",
    "vendorName": "MK beauty's",
    "vendorCode": "MKB",
    "category": "clothing"
  },
  {
    "stallNo": "38",
    "vendorName": "Vinuthna fashions",
    "vendorCode": "VTF",
    "category": "pattu fancy design sarees"
  },
  {
    "stallNo": "39",
    "vendorName": "Suveda luxury ayurveda",
    "vendorCode": "SLA",
    "category": "organic and ayurvedic cosmotics"
  },
  {
    "stallNo": "41",
    "vendorName": "Maa vaarahi collections",
    "vendorCode": "MVC",
    "category": "sarees, dresses, night wear,tops"
  },
  {
    "stallNo": "42 & 43",
    "vendorName": "sri_maguva",
    "vendorCode": "SMG",
    "category": "anti tarnish jewellery"
  },
  {
    "stallNo": "44 & 45",
    "vendorName": "New BAGGAGE stores",
    "vendorCode": "NBS",
    "category": "hand bags"
  },
  {
    "stallNo": "46",
    "vendorName": "SULEMAN OPTICALS MANGALAGIRI",
    "vendorCode": "SOM",
    "category": "opticals"
  },
  {
    "stallNo": "47",
    "vendorName": "SULEMAN FASHION'S",
    "vendorCode": "SLF",
    "category": "fashion"
  },
  {
    "stallNo": "48 & 49",
    "vendorName": "Joshe Boutique",
    "vendorCode": "JOB",
    "category": "ladies wear"
  },
  {
    "stallNo": "50, 51 & 52",
    "vendorName": "Nokia footware",
    "vendorCode": "AAD",
    "category": "footware"
  },
  {
    "stallNo": "53",
    "vendorName": "Sri Neehalini Saree House",
    "vendorCode": "SNSH",
    "category": "women wear"
  },
  {
    "stallNo": "54 & 55",
    "vendorName": "Murugan Sarees",
    "vendorCode": "MRS",
    "category": "sarees"
  },
  {
    "stallNo": "56",
    "vendorName": "Kumar Kavitha Nepal Rudraksha (VIJ)",
    "vendorCode": "KVN",
    "category": "spiritual"
  },
  {
    "stallNo": "58",
    "vendorName": "Sreematha Sarees",
    "vendorCode": "SMS",
    "category": "sarees"
  },
  {
    "stallNo": "59",
    "vendorName": "Shahensha handloom",
    "vendorCode": "SHH",
    "category": "sarees"
  },
  {
    "stallNo": "61",
    "vendorName": "LEATHER WORLD",
    "vendorCode": "LEW",
    "category": "footware"
  },
  {
    "stallNo": "63",
    "vendorName": "Tupperware",
    "vendorCode": "TPW",
    "category": "misc."
  },
  {
    "stallNo": "64",
    "vendorName": "Gadget store",
    "vendorCode": "GDS",
    "category": "gadgets,toys and wall arts"
  },
  {
    "stallNo": "65 & 66",
    "vendorName": "Lakshmi anjaneya bags and fancy",
    "vendorCode": "LABF",
    "category": "bags"
  },
  {
    "stallNo": "68 & 69",
    "vendorName": "Kota Sarees",
    "vendorCode": "KOS",
    "category": "sarees"
  },
  {
    "stallNo": "70 & 71",
    "vendorName": "Amazing Boutique",
    "vendorCode": "AMB",
    "category": "sarees & dresses"
  },
  {
    "stallNo": "72",
    "vendorName": "Sadhvi naturals",
    "vendorCode": "SAN",
    "category": "hand crafted hair care and skin care"
  },
  {
    "stallNo": "76",
    "vendorName": "Lac bangales costmise live making",
    "vendorCode": "LBC",
    "category": "bangles"
  },
  {
    "stallNo": "77",
    "vendorName": "Vaidya Sri",
    "vendorCode": "VDS",
    "category": "health care"
  },
  {
    "stallNo": "78, 79 & 80",
    "vendorName": "Guntur 99 store (House of return gifts)",
    "vendorCode": "GNS",
    "category": "gifts"
  },
  {
    "stallNo": "81",
    "vendorName": "Bhanicollections",
    "vendorCode": "BHC",
    "category": "kalamkaari"
  },
  {
    "stallNo": "82",
    "vendorName": "Lahari designer studio",
    "vendorCode": "LDS",
    "category": "clothing"
  },
  {
    "stallNo": "83",
    "vendorName": "Gowtham collections",
    "vendorCode": "GOC",
    "category": "kalamkaari"
  },
  {
    "stallNo": "73 & 74",
    "vendorName": "Raza Silk estate",
    "vendorCode": "RSE",
    "category": "silk sarees"
  },
  {
    "stallNo": "75",
    "vendorName": "Satyabhama Studio",
    "vendorCode": "SBS",
    "category": "designer studio"
  },
  {
    "stallNo": "76",
    "vendorName": "STYLO14(Pranivsha)",
    "vendorCode": "STY14",
    "category": "clothing"
  },
  {
    "stallNo": "77",
    "vendorName": "Kashmir goodwill",
    "vendorCode": "KGW",
    "category": "shawls & carpets"
  },
  {
    "stallNo": "78",
    "vendorName": "Lavanyatrendycollection",
    "vendorCode": "LTC",
    "category": "clothing"
  },
  {
    "stallNo": "79",
    "vendorName": "Kalamkari Mandiram",
    "vendorCode": "KKM",
    "category": "handlooms"
  },
  {
    "stallNo": "85",
    "vendorName": "Bansals ST 85",
    "vendorCode": "BS85",
    "category": "clothing"
  },
  {
    "stallNo": "87",
    "vendorName": "PRUDHVI INNOVATIONS ST 87",
    "vendorCode": "PI87",
    "category": "innovations"
  },
  {
    "stallNo": "88",
    "vendorName": "RBS fashion factory ST88",
    "vendorCode": "RBS88",
    "category": "fashion"
  },
  {
    "stallNo": "23",
    "vendorName": "Srinidhi silks ST 23",
    "vendorCode": "SS23",
    "category": "silks"
  }
];

  var DEFAULT_STALL_MASTER = IS_VIJ ? VIJAYAWADA_STALL_MASTER : [];
  var CITY_REMOTE_STALLS = [];
  var STALL_MASTER = DEFAULT_STALL_MASTER.slice(0);

  
  function showCityNotice(html) {
    if (!el.pendingBanner) return;
    el.pendingBanner.innerHTML = html;
    el.pendingBanner.style.display = html ? 'flex' : 'none';
  }

  function applyCityHeader() {
    if (IS_VIJ) return;
    function setText(sel, text) {
      var node = document.querySelector(sel);
      if (node) node.textContent = text;
    }
    setText('.hpb-brand-title', 'Half Price Days — ' + CITY_LABEL);
    setText('.hpb-hero-left h1', CITY_LABEL + ' Expo · Official Billing Portal');
    setVenueAddress(cityVenueAddress());
    fetch(DASHBOARD_API + '/api/cities', { mode: 'cors' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var city = ((data && data.cities) || []).find(function (c) { return String(c.code || c.id).toUpperCase() === CURRENT_CITY_ID; });
        if (!city) return;
        setText('.hpb-brand-title', 'Half Price Days — ' + city.name);
        setText('.hpb-hero-left h1', city.name + ' · Official Billing Portal');
        var pill = document.querySelector('.hpb-event-pill span:last-child');
        if (pill) pill.innerHTML = '<b>' + escapeHtml(city.venue || CITY_LABEL) + '</b> · ' + escapeHtml(city.dates || '');
        CITY_INFO = city;
        setVenueAddress(cityVenueAddress());
      })
      .catch(function () { });
  }

  function cityVenueAddress() {
    if (!CITY_INFO) return CITY_LABEL;
    var venue = String(CITY_INFO.venue || '').trim();
    var town = { VIJ: 'Vijayawada', HYD: 'Hyderabad', VSP: 'Visakhapatnam', BLR: 'Bengaluru' }[CURRENT_CITY_ID] || '';
    var parts = [venue || CITY_INFO.name || CITY_LABEL];
    if (town && parts[0].toLowerCase().indexOf(town.toLowerCase()) === -1) parts.push(town);
    return parts.join(', ');
  }

  // The venue address goes on the order, slip and Shopify order unless the customer chose home delivery
  function setVenueAddress(address) {
    defaultVenueAddress = address;
    if (!state.customer.isHomeDelivery) {
      state.customer.address = address;
      var addr = document.getElementById('hpb-cust-address');
      if (addr) addr.value = address;
    }
  }

  function billCopyDisplay(items, fallback) {
    var nos = [];
    (items || []).forEach(function (it) {
      String(it.billCopyNo || '').split(/[,;\s]+/).forEach(function (n) {
        n = n.trim();
        if (n && nos.indexOf(n) === -1) nos.push(n);
      });
    });
    return nos.length > 0 ? nos.join(', ') : (fallback || '--');
  }

  // Bill book series from the dashboard: each vendor owns ranges of HalfPe Bill Copy Numbers
  var BILL_SERIES = [];

  function fetchBillSeries() {
    fetch(DASHBOARD_API + '/api/bill-series/public?cityId=' + encodeURIComponent(CURRENT_CITY_ID), { mode: 'cors' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        BILL_SERIES = (data && Array.isArray(data.series)) ? data.series : [];
      })
      .catch(function (e) {
        console.warn('[HalfPe Expo] Bill series not loaded; vendor must be picked manually:', e.message);
      });
  }

  function findStallForBillCopy(copyNo) {
    var n = parseInt(String(copyNo || '').replace(/\D/g, ''), 10);
    if (!n) return null;
    var series = BILL_SERIES.find(function (s) { return n >= s.start && n <= s.end; });
    if (!series) return null;
    var code = String(series.vendorId || '').replace(/^v_/i, '').toUpperCase();
    var stallNo = String(series.stallNo || '').replace(/^Stall\s*/i, '').trim();
    var byName = function (st) { return String(st.vendorName || '').toLowerCase() === String(series.vendorName || '').toLowerCase(); };
    var found = STALL_MASTER.find(function (st) { return code && String(st.vendorCode || '').toUpperCase() === code && byName(st); }) ||
      STALL_MASTER.find(byName) ||
      STALL_MASTER.find(function (st) { return code && String(st.vendorCode || '').toUpperCase() === code; });
    if (found) return found;
    // The dashboard owns the series; if this page's stall list does not have the vendor yet, add it
    if (!stallNo || !series.vendorName) return null;
    var vendorCode = code || ('ST' + stallNo).slice(0, 4).toUpperCase();
    // Keep the stall number unique on this page (it may already belong to another vendor here); the
    // dashboard matches stalls by their digits, so "03-NDS" still records against Stall 03
    var taken = STALL_MASTER.some(function (st) { return String(st.stallNo).trim() === stallNo; });
    found = { stallNo: taken ? stallNo + '-' + vendorCode : stallNo, vendorName: series.vendorName, vendorCode: vendorCode, category: 'other' };
    STALL_MASTER.push(found);
    return found;
  }

  var billCopyAutoTimer = null;

  // Selects the vendor once the cashier pauses typing, then puts the cursor back in the bill copy field
  function scheduleStallFromBillCopy(item) {
    clearTimeout(billCopyAutoTimer);
    billCopyAutoTimer = setTimeout(function () {
      var stall = findStallForBillCopy(item.billCopyNo);
      if (!stall || String(stall.stallNo) === String(item.stallNo)) return;
      item.stallNo = stall.stallNo;
      item.vendorName = stall.vendorName;
      if (!item.isCustomTitle) item.title = '';
      renderItemRows();
      updateLiveReceipt();
      updateButtonStates();
      var card = el.itemsContainer && el.itemsContainer.querySelector('[data-id="' + item.id + '"]');
      var inp = card && card.querySelector('[data-field="billCopyNo"]');
      if (inp) {
        inp.focus();
        var len = inp.value.length;
        try { inp.setSelectionRange(len, len); } catch (e) { }
      }
    }, 450);
  }

  // Blocks payment when a HalfPe Bill Copy No. was already used on another order (or on two stalls in this bill).
  // If the dashboard cannot be reached the sale goes through; the dashboard still flags the duplicate.
  function withBillCopyCheck(proceed) {
    var nos = [];
    var stallByNo = {};
    for (var i = 0; i < state.items.length; i++) {
      var it = state.items[i];
      var parts = String(it.billCopyNo || '').split(/[,;\s]+/);
      for (var p = 0; p < parts.length; p++) {
        var no = parts[p].trim().toUpperCase();
        if (!no) continue;
        if (stallByNo[no] && stallByNo[no] !== String(it.stallNo)) {
          alert('HalfPe Bill Copy No. ' + no + ' is entered for two different stalls in this bill. Each bill copy belongs to one vendor.');
          return;
        }
        stallByNo[no] = String(it.stallNo);
        if (nos.indexOf(no) === -1) nos.push(no);
      }
    }
    if (nos.length === 0) return proceed();

    fetch(DASHBOARD_API + '/api/bill-copy/check', {
      method: 'POST',
      mode: 'cors',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ cityId: CURRENT_CITY_ID, billCopyNos: nos })
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        var dups = (data && data.duplicates) || [];
        if (dups.length > 0) {
          document.querySelectorAll('[data-field="billCopyNo"]').forEach(function (inp) {
            var vals = String(inp.value || '').toUpperCase().split(/[,;\s]+/);
            if (vals.some(function (v) { return dups.indexOf(v.trim()) !== -1; })) inp.classList.add('border-danger');
          });
          alert('HalfPe Bill Copy No. ' + dups.join(', ') + ' has already been used on another order. Please check the bill copy and enter the correct number.');
          return;
        }
        proceed();
      })
      .catch(function (e) {
        console.warn('[HalfPe Expo] Bill copy check unavailable, continuing:', e.message);
        proceed();
      });
  }

  function fetchDynamicCityStalls() {
    if (IS_VIJ) {
      console.log('[HalfPe Expo] City is VIJ: Preserving permanent Vijayawada vendors master (' + VIJAYAWADA_STALL_MASTER.length + ' stalls)');
      return;
    }
    var apiUrl = DASHBOARD_API + '/api/vendors?cityId=' + encodeURIComponent(CURRENT_CITY_ID);
    fetch(apiUrl, { mode: 'cors', headers: { 'x-city-id': CURRENT_CITY_ID } })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      })
      .then(function (data) {
        var list = (data && Array.isArray(data.vendors)) ? data.vendors : [];
        var remoteStalls = list.filter(function (item) {
          var v = item.vendor || item;
          return v.active !== false && String(v.cityId || '').toUpperCase() === CURRENT_CITY_ID;
        }).map(function (item) {
            var v = item.vendor || item;
            return {
              stallNo: String(v.stallNo || '').replace(/^Stall\s*/i, '').trim() || v.stallNo,
              vendorName: v.name,
              vendorCode: v.code || ('ST' + v.stallNo).slice(0, 4).toUpperCase(),
              category: v.category || 'Retail'
            };
          });
        CITY_REMOTE_STALLS = remoteStalls;
        STALL_MASTER = remoteStalls;
        syncFirstItemToStall();
        if (el.itemsContainer) renderItemRows();
        updateLiveReceipt();
        if (remoteStalls.length === 0) {
          showCityNotice('⚠️ <b>' + escapeHtml(CITY_LABEL) + '</b> ke liye abhi koi vendor registered nahi hai. Settlement dashboard me city "' + escapeHtml(CITY_LABEL) + '" select karke vendors add karein, phir page refresh karein.');
        } else {
          showCityNotice('');
        }
        console.log('[HalfPe Expo] Dynamically loaded ' + remoteStalls.length + ' stalls for city ' + CURRENT_CITY_ID);
      })
      .catch(function (e) {
        console.warn('[HalfPe Expo] Could not load stalls for ' + CURRENT_CITY_ID + ':', e.message);
        showCityNotice('⚠️ ' + escapeHtml(CITY_LABEL) + ' ke vendors load nahi ho paaye (' + escapeHtml(e.message) + '). Internet check karke page refresh karein.');
      });
  }

  function syncFirstItemToStall() {
    if (state && state.items && state.items.length > 0 && STALL_MASTER.length > 0) {
      var firstStall = STALL_MASTER[0];
      var known = STALL_MASTER.some(function (s) { return String(s.stallNo).trim() === String(state.items[0].stallNo || '').trim(); });
      if (!known || !state.items[0].isCustomTitle || !state.items[0].title || state.items[0].title.trim() === '') {
        state.items[0].stallNo = firstStall.stallNo;
        state.items[0].vendorName = firstStall.vendorName;
        state.items[0].title = generateAutoProductTitle(firstStall, 1);
        state.items[0].isCustomTitle = false;
        state.items[0].sku = generateProductSku(firstStall.vendorName, firstStall.stallNo, 1);
      }
    }
  }

  function loadStallMaster() {
    if (!IS_VIJ) {
      STALL_MASTER = CITY_REMOTE_STALLS;
      return;
    }
    var loadedStalls = [];

    // 1. First check dynamic blocks JSON script
    var dataEl = document.getElementById('hpb-stalls-data');
    if (dataEl && dataEl.textContent) {
      try {
        var parsed = JSON.parse(dataEl.textContent);
        if (Array.isArray(parsed) && parsed.length > 0) {
          parsed.forEach(function (s) {
            if (s && s.stallNo) {
              loadedStalls.push({
                stallNo: String(s.stallNo).trim(),
                vendorName: String(s.vendorName || ('Vendor #' + s.stallNo)).trim(),
                vendorCode: String(s.vendorCode || ('ST' + s.stallNo)).trim().toUpperCase(),
                category: String(s.category || 'fashion').trim().toLowerCase()
              });
            }
          });
        }
      } catch (e) {
        console.warn('[HalfPe Expo] Could not parse stalls JSON:', e);
      }
    }

    // 2. Check bulk list textarea override
    var appEl = document.getElementById('hpd-billing-app');
    if (appEl && appEl.dataset.stallsBulk && appEl.dataset.stallsBulk.trim()) {
      var lines = appEl.dataset.stallsBulk.split('\n');
      var bulkList = [];
      lines.forEach(function (line) {
        line = line.trim();
        if (!line || line.indexOf('#') === 0) return;
        var parts = line.split('|').map(function (p) { return p.trim(); });
        if (parts.length >= 2 && parts[0]) {
          bulkList.push({
            stallNo: parts[0],
            vendorName: parts[1],
            vendorCode: parts[2] || ('ST' + parts[0]).slice(0, 3).toUpperCase(),
            category: parts[3] || 'fashion'
          });
        }
      });
      if (bulkList.length > 0) {
        loadedStalls = bulkList;
      }
    }

    // 3. Fallback to default 20 stalls if nothing specified
    if (loadedStalls.length === 0) {
      loadedStalls = DEFAULT_STALL_MASTER.slice(0);
    }

    STALL_MASTER = loadedStalls;

    // Sync initial item if it has default stall
    if (state && state.items && state.items.length > 0 && STALL_MASTER.length > 0) {
      var firstStall = STALL_MASTER[0];
      if (!state.items[0].isCustomTitle || !state.items[0].title || state.items[0].title.trim() === '') {
        state.items[0].stallNo = firstStall.stallNo;
        state.items[0].vendorName = firstStall.vendorName;
        state.items[0].title = generateAutoProductTitle(firstStall, 1);
        state.items[0].isCustomTitle = false;
        state.items[0].sku = generateProductSku(firstStall.vendorName, firstStall.stallNo, 1);
      }
    }
  }

  function getStallInfo(stallNumberStr) {
    var raw = (stallNumberStr || '').toString().trim();
    if (!raw) raw = (STALL_MASTER.length > 0 ? STALL_MASTER[0].stallNo : '01');

    var found = STALL_MASTER.find(function (s) {
      return String(s.stallNo).trim() === raw ||
             (raw.length === 1 && String(s.stallNo).trim() === ('0' + raw)) ||
             (String(s.stallNo).trim().length === 1 && ('0' + String(s.stallNo).trim()) === raw);
    });
    if (found) return found;

    // Fallback support for any unlisted custom stall
    return {
      stallNo: raw,
      vendorName: 'Partner Vendor #' + raw,
      vendorCode: ('ST' + raw + 'X').slice(0, 3).toUpperCase(),
      category: 'other'
    };
  }

  // =========================================================================
  // 2. HELPERS & FORMATTERS
  // =========================================================================
  function formatINR(num) {
    if (isNaN(num)) return '₹0';
    return '₹' + Math.round(num).toLocaleString('en-IN');
  }

  function uid() {
    return 'item_' + Math.random().toString(36).substr(2, 9);
  }

  function generateBillNo() {
    var d = new Date();
    var ymd = d.getFullYear().toString().substr(-2) +
      ('0' + (d.getMonth() + 1)).slice(-2) +
      ('0' + d.getDate()).slice(-2);
    var rand = Math.floor(1000 + Math.random() * 9000);
    return 'HPD-' + CURRENT_CITY_ID + '-' + ymd + '-' + rand;
  }

  // SKU rule: HPD- + first 3 letters of vendor name (uppercase) + stall number + - + 4-digit sequence
  function generateProductSku(vendorName, stallNo, sequence) {
    var cleanVendor = (vendorName || 'GEN').replace(/[^a-zA-Z]/g, '').toUpperCase();
    if (cleanVendor.length < 3) {
      cleanVendor = (cleanVendor + 'XXX').slice(0, 3);
    } else {
      cleanVendor = cleanVendor.slice(0, 3);
    }
    var cleanStall = (stallNo || '01').toString().replace(/\D/g, '');
    if (cleanStall.length === 1) cleanStall = '0' + cleanStall;
    if (!cleanStall) cleanStall = '01';

    var seqNum = sequence || 1;
    var seqStr = ('0000' + seqNum).slice(-4);
    return 'HPD-' + cleanVendor + cleanStall + '-' + seqStr;
  }

  // Category clean nouns for intuitive, short product titles (e.g. PSC-Shoes 1)
  function getCategoryNoun(category) {
    var cat = (category || '').toLowerCase().trim();
    if (cat.indexOf('footwear') !== -1 || cat.indexOf('footware') !== -1 || cat.indexOf('shoe') !== -1) return 'Shoes';
    if (cat.indexOf('perfume') !== -1) return 'Perfume';
    if (cat.indexOf('jewel') !== -1 || cat.indexOf('bangle') !== -1 || cat.indexOf('tarnish') !== -1) return 'Jewel';
    if (cat.indexOf('saree') !== -1) return 'Saree';
    if (cat.indexOf('bag') !== -1) return 'Bag';
    if (cat.indexOf('optical') !== -1 || cat.indexOf('spec') !== -1) return 'Opticals';
    if (cat.indexOf('kitchen') !== -1 || cat.indexOf('appliance') !== -1) return 'Kitchen';
    if (cat.indexOf('gadget') !== -1 || cat.indexOf('toy') !== -1) return 'Gadgets';
    if (cat.indexOf('cosmetic') !== -1 || cat.indexOf('hair') !== -1 || cat.indexOf('skin') !== -1 || cat.indexOf('health') !== -1) return 'Beauty';
    if (cat.indexOf('gift') !== -1 || cat.indexOf('decor') !== -1 || cat.indexOf('charm') !== -1 || cat.indexOf('spiritual') !== -1) return 'Decor';
    if (cat.indexOf('cloth') !== -1 || cat.indexOf('textile') !== -1 || cat.indexOf('wear') !== -1 || cat.indexOf('dress') !== -1 || cat.indexOf('frock') !== -1 || cat.indexOf('kalamkaari') !== -1 || cat.indexOf('fashion') !== -1) return 'Apparel';
    return 'Item';
  }

  // Clean vendor short code (e.g. PSC, AZP, DTS, SKC)
  function getVendorShortCode(vendorName, vendorCode) {
    if (vendorCode && vendorCode.length >= 2 && vendorCode !== 'HPDALL') return vendorCode.toUpperCase();
    var words = (vendorName || '').trim().split(/\s+/).filter(Boolean);
    if (words.length >= 2) {
      var inits = words.map(function (w) { return w.charAt(0); }).join('').toUpperCase();
      if (inits.length >= 2 && inits.length <= 4) return inits;
    }
    return (vendorName || 'EXPO').replace(/[^a-zA-Z0-9]/g, '').toUpperCase().slice(0, 3) || 'ITM';
  }

  // Generate unique Auto-Title: e.g. PSC-Shoes 1, PSC-Shoes 2
  function generateAutoProductTitle(stallInfo, sequenceInStall) {
    var code = getVendorShortCode(stallInfo.vendorName, stallInfo.vendorCode);
    var noun = getCategoryNoun(stallInfo.category);
    var num = sequenceInStall || 1;
    return code + '-' + noun + ' ' + num;
  }

  // Persistent Counter per Stall across all customer bills on this terminal
  function getStallBaseCount(stallNo) {
    try {
      var store = JSON.parse(localStorage.getItem('hpb_stall_seq_counts') || '{}');
      return parseInt(store[stallNo] || '0', 10);
    } catch (e) {
      return 0;
    }
  }

  function incrementStallCountsForBill(items) {
    try {
      var store = JSON.parse(localStorage.getItem('hpb_stall_seq_counts') || '{}');
      var billStallCounts = {};
      (items || []).forEach(function (it) {
        var s = (it.stallNo || '01').toString();
        billStallCounts[s] = (billStallCounts[s] || 0) + 1;
      });
      Object.keys(billStallCounts).forEach(function (s) {
        var cur = parseInt(store[s] || '0', 10);
        store[s] = cur + billStallCounts[s];
      });
      localStorage.setItem('hpb_stall_seq_counts', JSON.stringify(store));
    } catch (e) {}
  }

  function escapeHtml(str) {
    return (str || '').toString()
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  function formatReceiptDate(d) {
    return d.toLocaleDateString('en-IN', {
      day: '2-digit',
      month: 'short',
      year: 'numeric'
    }) + ' ' + d.toLocaleTimeString('en-IN', {
      hour: '2-digit',
      minute: '2-digit'
    });
  }

  // =========================================================================
  // 3. MASTER APPLICATION STATE
  // =========================================================================
  var defaultVenueAddress = 'SVN Conventions, Enikepadu, Poranki, Vijayawada, Andhra Pradesh';

  var state = {
    billNo: generateBillNo(),
    timestamp: new Date(),
    terminal: 'Terminal 01 (Central Billing Desk)',
    customer: {
      name: '',
      phone: '',
      email: '',
      address: defaultVenueAddress,
      isHomeDelivery: false
    },
    paymentMode: 'razorpay', // 'razorpay' | 'cash'
    cashTendered: 0,
    items: [
      {
        id: uid(),
        stallNo: '01',
        vendorName: 'Profit Shoe Company',
        billCopyNo: '',
        title: 'PSC-Shoes 1',
        isCustomTitle: false,
        eventPrice: '',
        mrp: 0, // auto: eventPrice * 2
        sku: 'HPD-PRO01-0001'
      }
    ],
    lastPaidBill: null
  };

  // DOM Elements Cache
  var el = {};

  function initElements() {
    el.app = document.getElementById('hpd-billing-app');
    if (!el.app) return false;

    if (!IS_VIJ) {
      // The theme setting holds the Vijayawada venue; other cities use their own venue from the dashboard
      defaultVenueAddress = cityVenueAddress();
      if (!state.customer.isHomeDelivery) {
        state.customer.address = defaultVenueAddress;
      }
    } else if (el.app.dataset.venueAddress) {
      defaultVenueAddress = el.app.dataset.venueAddress;
      if (!state.customer.isHomeDelivery) {
        state.customer.address = defaultVenueAddress;
      }
    }

    // Header & Meta
    el.billNoDisplay = document.getElementById('hpb-rec-bill-no');
    el.timeDisplay = document.getElementById('hpb-rec-time');
    el.inputSalesperson = document.getElementById('hpb-input-salesperson');
    el.btnReset = document.getElementById('hpb-btn-reset');
    el.pendingBanner = document.getElementById('hpb-pending-banner');

    // Customer Tile
    el.inputCustName = document.getElementById('hpb-cust-name');
    el.inputCustPhone = document.getElementById('hpb-cust-phone');
    el.inputCustEmail = document.getElementById('hpb-cust-email');
    el.inputCustAddress = document.getElementById('hpb-cust-address');
    el.toggleDelivery = document.getElementById('hpb-toggle-delivery');

    // Items Repeater
    el.itemsContainer = document.getElementById('hpb-items-list');
    el.btnAddItem = document.getElementById('hpb-btn-add-item');

    // Payment Modes & Cash Calculator
    el.paymodeCards = document.querySelectorAll('[data-paymode]');
    el.cashCalculatorBox = document.getElementById('hpb-cash-calculator-box');
    el.inputCashTendered = document.getElementById('hpb-cash-tendered');
    el.cashChangeDisplay = document.getElementById('hpb-cash-change');
    el.cashChipExact = document.getElementById('hpb-chip-exact-btn');
    el.cashChips = document.querySelectorAll('.hpb-chip-btn');

    // Right Column Live Receipt
    el.recCustName = document.getElementById('hpb-rec-cust-name');
    el.recCustPhone = document.getElementById('hpb-rec-cust-phone');
    el.recStallsList = document.getElementById('hpb-rec-stalls-list');
    el.recItemsList = document.getElementById('hpb-rec-items-list');
    el.recTotalMrp = document.getElementById('hpb-rec-total-mrp');
    el.recTotalSavings = document.getElementById('hpb-rec-total-savings');
    el.recNetPayable = document.getElementById('hpb-rec-net-payable');
    el.recGstNote = document.getElementById('hpb-rec-gst-note');

    // Action Buttons (3 Modes: COD, Razorpay, Pinelabs)
    el.btnPayRazorpay = document.getElementById('hpb-btn-razorpay');
    el.btnPayRzpVal = document.getElementById('hpb-rzp-btn-val');
    el.btnCash = document.getElementById('hpb-btn-cash');
    el.btnPinelabs = document.getElementById('hpb-btn-pinelabs');

    // Mobile Bottom Floating Dock
    el.mobDock = document.getElementById('hpb-mobile-dock');
    el.mobNetPayable = document.getElementById('hpb-mob-net-payable');
    el.mobSavings = document.getElementById('hpb-mob-savings');
    el.mobBtnCash = document.getElementById('hpb-mob-btn-cash');
    el.mobBtnRzp = document.getElementById('hpb-mob-btn-rzp');
    el.mobBtnPinelabs = document.getElementById('hpb-mob-btn-pinelabs');

    // Receipt Modal & Confirmation Dialog
    el.modal = document.getElementById('hpb-invoice-modal');
    el.modalClose = document.getElementById('hpb-modal-close');
    el.btnConfirmNewBill = document.getElementById('hpb-btn-confirm-new-bill');
    el.invoicePaperRoot = document.getElementById('hpb-invoice-paper-root');
    el.btnPrintInvoice = document.getElementById('hpb-btn-print-invoice');
    el.btnWhatsappShare = document.getElementById('hpb-btn-whatsapp-share');

    return true;
  }

  // =========================================================================
  // 4. CALCULATIONS & MULTI-VENDOR GROUPING
  // =========================================================================
  function getCalculatedTotals() {
    var totalPrice = 0;
    var totalMrp = 0;

    state.items.forEach(function (item) {
      var p = parseFloat(item.eventPrice) || 0;
      var m = p * 2; // MRP is ALWAYS 2 × Event Price (Spec Section 5, Page 6)
      totalPrice += p;
      totalMrp += m;
    });

    var totalSavings = Math.max(0, totalMrp - totalPrice);
    var overallDiscount = totalMrp > 0 ? 50 : 0;
    var rawCashGiven = parseFloat(state.cashTendered);
    var cashGiven = (!isNaN(rawCashGiven) && rawCashGiven > 0) ? rawCashGiven : totalPrice;
    var changeToReturn = Math.max(0, cashGiven - totalPrice);

    return {
      totalPrice: totalPrice,
      totalMrp: totalMrp,
      totalSavings: totalSavings,
      overallDiscount: overallDiscount,
      payable: totalPrice,
      cashTendered: cashGiven,
      changeToReturn: changeToReturn
    };
  }

  // Groups items by Stall Number for Multi-Vendor Split
  function getStallGroups() {
    var groupsMap = {};

    state.items.forEach(function (item) {
      var sNo = (item.stallNo || '01').toString();
      var stallObj = getStallInfo(sNo);

      if (!groupsMap[sNo]) {
        groupsMap[sNo] = {
          stallNo: sNo,
          vendorName: item.vendorName || stallObj.vendorName,
          itemsCount: 0,
          subtotal: 0,
          billCopyNos: [],
          items: []
        };
      }

      var p = parseFloat(item.eventPrice) || 0;
      var copyNo = String(item.billCopyNo || '').trim();
      if (copyNo && groupsMap[sNo].billCopyNos.indexOf(copyNo) === -1) groupsMap[sNo].billCopyNos.push(copyNo);
      groupsMap[sNo].itemsCount += 1;
      groupsMap[sNo].subtotal += p;
      groupsMap[sNo].items.push(item);
    });

    return Object.keys(groupsMap).map(function (k) {
      // The pink bill copy numbers typed at the counter, used by the dashboard as the vendor's bill-book number
      groupsMap[k].billCopyNo = groupsMap[k].billCopyNos.join(', ');
      return groupsMap[k];
    });
  }

  // =========================================================================
  // 5. VALIDATION RULES (CLIENT SPEC SECTION 5)
  // =========================================================================
  function validateBill(silent) {
    // 1. Customer Name: mandatory (BUG-18 & BUG-24)
    var name = (state.customer.name || (el.inputCustName ? el.inputCustName.value : '')).trim();
    if (!name || name.length < 2) {
      if (!silent) {
        if (el.inputCustName) {
          el.inputCustName.classList.add('border-danger');
          el.inputCustName.focus();
        }
        var errNameEl = document.getElementById('err-cust-name');
        if (errNameEl) errNameEl.style.display = 'block';
        alert('Please enter a valid customer name (Mandatory).');
      }
      return false;
    }
    state.customer.name = name;

    // 2. Mobile: clean non-digits, extract last 10 digits
    var rawPhone = (state.customer.phone || '').replace(/\D/g, '');
    var phone = rawPhone.length > 10 ? rawPhone.slice(-10) : rawPhone;
    if (phone.length === 10 && /^[6-9]\d{9}$/.test(phone)) {
      state.customer.phone = phone;
    } else {
      if (!silent) alert('Please enter a valid 10-digit mobile number starting with 6, 7, 8, or 9.');
      if (!silent && el.inputCustPhone) el.inputCustPhone.focus();
      return false;
    }

    // 3. Email (optional): clean if invalid instead of blocking
    var email = (state.customer.email || '').trim();
    if (email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      state.customer.email = '';
    }

    // 4. Products check
    if (!IS_VIJ && STALL_MASTER.length === 0) {
      if (!silent) alert(CITY_LABEL + ' ke liye koi vendor registered nahi hai. Pehle dashboard me vendors add karein.');
      return false;
    }
    if (!state.items || state.items.length === 0) {
      if (!silent) alert('Please add at least one product to the bill.');
      return false;
    }

    var seenBillCopies = {};
    for (var i = 0; i < state.items.length; i++) {
      var it = state.items[i];

      // Stall selection
      if (!it.stallNo) {
        it.stallNo = '01';
      }

      // HalfPe Bill Copy No. (Mandatory per BUG-20 & BUG-24)
      var copyNo = (it.billCopyNo || '').trim();
      if (!copyNo) {
        if (!silent) {
          alert('Please enter a Bill Copy Number for Item #' + (i + 1) + ' (Mandatory).');
          var copyInput = document.querySelector('[data-item-index="' + i + '"] .hpb-input-bill-copy');
          if (copyInput) {
            copyInput.classList.add('border-danger');
            copyInput.focus();
          }
        }
        return false;
      }
      if (!/^\d{1,10}$/.test(copyNo)) {
        if (!silent) {
          alert('HalfPe Bill Copy No. for Item #' + (i + 1) + ' must be the number printed on the bill book (digits only, e.g. 1045).');
          var badCopyInput = document.querySelector('[data-id="' + it.id + '"] [data-field="billCopyNo"]');
          if (badCopyInput) {
            badCopyInput.classList.add('border-danger');
            badCopyInput.focus();
          }
        }
        return false;
      }
      it.billCopyNo = copyNo;
      seenBillCopies[copyNo] = true;

      // Product Title (Auto-fallback)
      var title = (it.title || '').trim();
      if (!title || title.length < 2) {
        var sInfo = getStallInfo(it.stallNo);
        title = generateAutoProductTitle(sInfo, i + 1);
        it.title = title;
      }

      // Event Price (> 0)
      var price = parseFloat(it.eventPrice) || 0;
      if (price <= 0) {
        if (!silent) alert('Please enter Event Price (₹) for Item #' + (i + 1) + '.');
        return false;
      }
    }

    // 5. Cash Mode check: Auto-resolve cash tendered to exact payable (NEVER BLOCK CASHIER!)
    var totals = getCalculatedTotals();
    if (state.paymentMode === 'cash') {
      var enteredCash = parseFloat(state.cashTendered);
      if (isNaN(enteredCash) || enteredCash <= 0 || enteredCash < totals.payable) {
        // Auto-fix to exact payable so cash recording NEVER fails or blocks!
        state.cashTendered = totals.payable;
        if (el.inputCashTendered && (!enteredCash || enteredCash < totals.payable)) {
          el.inputCashTendered.value = totals.payable > 0 ? totals.payable : '';
        }
      }
    }

    return true;
  }

  function updateButtonStates() {
    var isValid = validateBill(true);

    if (el.btnPayRazorpay) {
      if (isValid) {
        el.btnPayRazorpay.classList.remove('hpb-btn-disabled');
      } else {
        el.btnPayRazorpay.classList.add('hpb-btn-disabled');
      }
    }

    if (el.btnCash) {
      if (isValid) {
        el.btnCash.classList.remove('hpb-btn-disabled');
      } else {
        el.btnCash.classList.add('hpb-btn-disabled');
      }
    }

    if (el.mobBtnRzp) {
      if (isValid) {
        el.mobBtnRzp.classList.remove('hpb-btn-disabled');
      } else {
        el.mobBtnRzp.classList.add('hpb-btn-disabled');
      }
    }

    if (el.mobBtnCash) {
      if (isValid) {
        el.mobBtnCash.classList.remove('hpb-btn-disabled');
      } else {
        el.mobBtnCash.classList.add('hpb-btn-disabled');
      }
    }
  }

  // =========================================================================
  // 6. RENDER PRODUCT TILES (REPEATABLE)
  // =========================================================================
  function renderItemRows() {
    if (!el.itemsContainer) return;
    el.itemsContainer.innerHTML = '';

    // Calculate running SKU count per stall
    var stallCounts = {};

    state.items.forEach(function (item, index) {
      var sNo = (item.stallNo || '01').toString();
      stallCounts[sNo] = (stallCounts[sNo] || 0) + 1;

      var stallInfo = getStallInfo(sNo);
      item.vendorName = stallInfo.vendorName;

      var baseCount = getStallBaseCount(sNo);
      var runningSeq = baseCount + stallCounts[sNo];
      item.sku = generateProductSku(stallInfo.vendorName, sNo, runningSeq);

      // Auto-assign clean non-duplicate title if not customized
      if (!item.isCustomTitle || !item.title || item.title.trim() === '') {
        item.title = generateAutoProductTitle(stallInfo, runningSeq);
        item.isCustomTitle = false;
      }

      var price = parseFloat(item.eventPrice) || 0;
      item.mrp = price * 2; // Auto-doubled

      var itemCard = document.createElement('div');
      itemCard.className = 'hpb-item-card';
      itemCard.dataset.id = item.id;

      // Build options for Stalls dynamically
      var stallOptionsHtml = '';
      var stallOptionsListHtml = '';
      STALL_MASTER.forEach(function (sInfo) {
        var sNum = String(sInfo.stallNo).trim();
        var selected = (sNum === sNo);
        var selectedAttr = selected ? 'selected' : '';
        stallOptionsHtml += '<option value="' + escapeHtml(sNum) + '" ' + selectedAttr + '>Stall #' + escapeHtml(sNum) + ' · ' + escapeHtml(sInfo.vendorName) + '</option>';

        stallOptionsListHtml += [
          '<div class="hpb-stall-option' + (selected ? ' hpb-selected' : '') + '" ',
          '     data-stall="' + escapeHtml(sNum) + '" ',
          '     data-vendor="' + escapeHtml(sInfo.vendorName) + '" ',
          '     data-code="' + escapeHtml(sInfo.vendorCode || '') + '" ',
          '     role="option" aria-selected="' + (selected ? 'true' : 'false') + '">',
          '  <div class="hpb-stall-option-main">',
          '    <span class="hpb-stall-pill">Stall #' + escapeHtml(sNum) + '</span>',
          '    <span class="hpb-stall-name">' + escapeHtml(sInfo.vendorName) + '</span>',
          '  </div>',
          (selected ? '  <svg class="hpb-stall-check" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#0E8A4D" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6L9 17l-5-5"/></svg>' : ''),
          '</div>'
        ].join('');
      });

      // If current item stall is not in STALL_MASTER, include it as selected
      var foundCurrent = STALL_MASTER.some(function (s) { return String(s.stallNo).trim() === sNo; });
      if (!foundCurrent && sNo) {
        var curInfo = getStallInfo(sNo);
        stallOptionsHtml += '<option value="' + escapeHtml(sNo) + '" selected>Stall #' + escapeHtml(sNo) + ' · ' + escapeHtml(curInfo.vendorName) + '</option>';
        stallOptionsListHtml += [
          '<div class="hpb-stall-option hpb-selected" ',
          '     data-stall="' + escapeHtml(sNo) + '" ',
          '     data-vendor="' + escapeHtml(curInfo.vendorName) + '" ',
          '     data-code="' + escapeHtml(curInfo.vendorCode || '') + '" ',
          '     role="option" aria-selected="true">',
          '  <div class="hpb-stall-option-main">',
          '    <span class="hpb-stall-pill">Stall #' + escapeHtml(sNo) + '</span>',
          '    <span class="hpb-stall-name">' + escapeHtml(curInfo.vendorName) + '</span>',
          '  </div>',
          '  <svg class="hpb-stall-check" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#0E8A4D" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6L9 17l-5-5"/></svg>',
          '</div>'
        ].join('');
      }

      itemCard.innerHTML = [
        '<div class="hpb-item-top">',
        '  <div class="hpb-item-index">',
        '    <span>Item #' + (index + 1) + '</span>',
        '    <span style="font-size:0.75rem; color:var(--hpd-ink-muted); font-weight:600;">(Stall #' + sNo + ' · ' + escapeHtml(item.vendorName) + ')</span>',
        '  </div>',
        '  <div class="hpb-item-actions">',
        (state.items.length > 1 ? '    <button type="button" class="hpb-btn-remove-item" data-action="remove-item" title="Remove Product"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><path d="M18 6L6 18M6 6l12 12"/></svg></button>' : ''),
        '  </div>',
        '</div>',

        // Unified 12-Column Responsive Item Grid
        '<div class="hpb-item-grid">',
        '  <div class="hpb-form-group col-stall">',
        '    <label class="hpb-label">Stall Number *</label>',
        '    <div class="hpb-stall-combobox" data-stall-combobox="' + item.id + '">',
        '      <select class="hpb-select hpb-stall-hidden-select" data-field="stallNo" style="display:none;">' + stallOptionsHtml + '</select>',
        '      <button type="button" class="hpb-stall-trigger" aria-haspopup="listbox" aria-expanded="false" title="Click to search or select stall">',
        '        <div class="hpb-stall-trigger-content">',
        '          <span class="hpb-stall-badge">Stall #' + escapeHtml(sNo) + '</span>',
        '          <span class="hpb-stall-trigger-vendor">' + escapeHtml(item.vendorName) + '</span>',
        '        </div>',
        '        <svg class="hpb-stall-chevron" width="10" height="6" viewBox="0 0 10 6" fill="none">',
        '          <path d="M1 1L5 5L9 1" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>',
        '        </svg>',
        '      </button>',
        '      <div class="hpb-stall-menu" style="display:none;" role="listbox">',
        '        <div class="hpb-stall-search-wrap">',
        '          <svg class="hpb-stall-search-icon" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>',
        '          <input type="text" class="hpb-stall-search-input" placeholder="Type Stall # (e.g. 02) or Vendor name..." autocomplete="off" spellcheck="false">',
        '          <button type="button" class="hpb-stall-search-clear" style="display:none;" title="Clear">×</button>',
        '        </div>',
        '        <div class="hpb-stall-options">' + stallOptionsListHtml + '</div>',
        '        <div class="hpb-stall-no-match" style="display:none;">No matching stall or vendor found</div>',
        '      </div>',
        '    </div>',
        '  </div>',

        // Hidden fields preserved for calculation & backend order sync
        '  <input type="hidden" data-field="vendorName" value="' + escapeHtml(item.vendorName) + '">',
        '  <input type="hidden" data-field="mrp" value="' + (item.mrp || 0) + '">',
        '  <input type="hidden" data-field="sku" value="' + escapeHtml(item.sku) + '">',

        '  <div class="hpb-form-group col-billcopy">',
        '    <label class="hpb-label">HalfPe Bill Copy No. *</label>',
        '    <input type="text" class="hpb-input hpb-input-bill-copy" data-field="billCopyNo" value="' + escapeHtml(item.billCopyNo) + '" placeholder="e.g. 1045" inputmode="numeric" autocomplete="off" style="font-family:var(--hpd-font-mono); font-weight:700;" required>',
        '  </div>',

        '  <div class="hpb-form-group col-title">',
        '    <label class="hpb-label" style="display:flex; justify-content:space-between; align-items:center;">',
        '      <span>Product Title *</span>',
        '      <span style="font-size:0.68rem; font-weight:700; color:#0E8A4D; background:#E8F5E9; padding:1px 6px; border-radius:4px;">✓ Auto</span>',
        '    </label>',
        '    <input type="text" class="hpb-input" data-field="title" value="' + escapeHtml(item.title) + '" placeholder="e.g. ' + escapeHtml(item.title) + '" style="font-weight:700;" required>',
        '  </div>',

        '  <div class="hpb-form-group col-price">',
        '    <label class="hpb-label">Event Price (₹) *</label>',
        '    <div class="hpb-input-group">',
        '      <span class="hpb-input-prefix">₹</span>',
        '      <input type="number" min="1" step="1" class="hpb-input" data-field="eventPrice" value="' + (item.eventPrice || '') + '" placeholder="600" required>',
        '    </div>',
        '  </div>',
        '</div>'
      ].join('');

      el.itemsContainer.appendChild(itemCard);
    });

    bindItemCardEvents();
    updateLiveReceipt();
    updateButtonStates();
  }

  function bindItemCardEvents() {
    var cards = el.itemsContainer.querySelectorAll('.hpb-item-card');
    cards.forEach(function (card) {
      var id = card.dataset.id;
      var targetItem = state.items.find(function (i) { return i.id === id; });
      if (!targetItem) return;

      // Inputs handling (exclude stall search input)
      card.querySelectorAll('input:not(.hpb-stall-search-input), select:not(.hpb-stall-hidden-select)').forEach(function (inp) {
        inp.addEventListener('input', function () {
          var field = inp.dataset.field;
          if (!field) return;

          if (field === 'eventPrice') {
            targetItem.eventPrice = parseFloat(inp.value) || 0;
            targetItem.mrp = targetItem.eventPrice * 2;
            var mrpInp = card.querySelector('[data-field="mrp"]');
            if (mrpInp) mrpInp.value = formatINR(targetItem.mrp);
          } else if (field === 'title') {
            targetItem.title = inp.value;
            targetItem.isCustomTitle = (inp.value.trim().length > 0);
          } else if (field === 'stallNo') {
            targetItem.stallNo = inp.value;
            var sInfo = getStallInfo(inp.value);
            targetItem.vendorName = sInfo.vendorName;
            if (!targetItem.isCustomTitle) {
              targetItem.title = '';
            }
            var vendorInp = card.querySelector('[data-field="vendorName"]');
            if (vendorInp) vendorInp.value = sInfo.vendorName;
            renderItemRows();
            return;
          } else {
            targetItem[field] = inp.value;
            if (field === 'billCopyNo') {
              inp.classList.remove('border-danger');
              scheduleStallFromBillCopy(targetItem);
            }
          }

          updateLiveReceipt();
          updateButtonStates();
        });
      });

      // Searchable Stall Combobox
      var combobox = card.querySelector('.hpb-stall-combobox');
      if (combobox) {
        var triggerBtn = combobox.querySelector('.hpb-stall-trigger');
        var menu = combobox.querySelector('.hpb-stall-menu');
        var searchInput = combobox.querySelector('.hpb-stall-search-input');
        var clearBtn = combobox.querySelector('.hpb-stall-search-clear');
        var optElements = combobox.querySelectorAll('.hpb-stall-option');
        var noMatch = combobox.querySelector('.hpb-stall-no-match');

        function openMenu() {
          // Close other open stall menus across cards
          document.querySelectorAll('.hpb-stall-menu').forEach(function (m) {
            if (m !== menu) {
              m.style.display = 'none';
              var p = m.closest('.hpb-stall-combobox');
              if (p) {
                var btn = p.querySelector('.hpb-stall-trigger');
                if (btn) btn.classList.remove('hpb-is-open');
              }
            }
          });

          menu.style.display = 'flex';
          triggerBtn.classList.add('hpb-is-open');
          triggerBtn.setAttribute('aria-expanded', 'true');

          searchInput.value = '';
          clearBtn.style.display = 'none';
          optElements.forEach(function (o) {
            o.style.display = 'flex';
            o.classList.remove('hpb-highlighted');
          });
          if (noMatch) noMatch.style.display = 'none';

          var selectedOpt = combobox.querySelector('.hpb-stall-option.hpb-selected');
          if (selectedOpt) {
            selectedOpt.classList.add('hpb-highlighted');
            selectedOpt.scrollIntoView({ block: 'nearest' });
          }

          // Focus search input immediately so cashier can type
          setTimeout(function () {
            searchInput.focus();
          }, 30);
        }

        function closeMenu() {
          menu.style.display = 'none';
          triggerBtn.classList.remove('hpb-is-open');
          triggerBtn.setAttribute('aria-expanded', 'false');
        }

        function selectStall(chosenStallNo) {
          if (!chosenStallNo) return;
          targetItem.stallNo = chosenStallNo;
          var sInfo = getStallInfo(chosenStallNo);
          targetItem.vendorName = sInfo.vendorName;

          if (!targetItem.isCustomTitle) {
            targetItem.title = '';
          }

          var hiddenSel = combobox.querySelector('.hpb-stall-hidden-select');
          if (hiddenSel) hiddenSel.value = chosenStallNo;

          closeMenu();
          renderItemRows();
        }

        triggerBtn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          if (menu.style.display === 'none' || !menu.style.display) {
            openMenu();
          } else {
            closeMenu();
          }
        });

        // Live Stall & Vendor filtering
        searchInput.addEventListener('input', function () {
          var q = searchInput.value.trim().toLowerCase();
          clearBtn.style.display = q ? 'block' : 'none';

          var visibleCount = 0;
          var firstVisible = null;

          optElements.forEach(function (opt) {
            var stallNum = (opt.dataset.stall || '').toLowerCase();
            var vendor = (opt.dataset.vendor || '').toLowerCase();
            var code = (opt.dataset.code || '').toLowerCase();

            var numMatch = false;
            if (stallNum === q || stallNum.indexOf(q) !== -1) {
              numMatch = true;
            } else {
              var parsedS = parseInt(stallNum, 10);
              var parsedQ = parseInt(q, 10);
              if (!isNaN(parsedS) && !isNaN(parsedQ) && parsedS === parsedQ) {
                numMatch = true;
              }
            }

            var vendorMatch = vendor.indexOf(q) !== -1 || code.indexOf(q) !== -1;
            var fullMatch = ('stall ' + stallNum).indexOf(q) !== -1 || ('stall #' + stallNum).indexOf(q) !== -1;

            if (!q || numMatch || vendorMatch || fullMatch) {
              opt.style.display = 'flex';
              opt.classList.remove('hpb-highlighted');
              visibleCount++;
              if (!firstVisible) firstVisible = opt;
            } else {
              opt.style.display = 'none';
              opt.classList.remove('hpb-highlighted');
            }
          });

          if (firstVisible) {
            firstVisible.classList.add('hpb-highlighted');
          }

          if (noMatch) {
            noMatch.style.display = (visibleCount === 0) ? 'block' : 'none';
          }
        });

        clearBtn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          searchInput.value = '';
          clearBtn.style.display = 'none';
          optElements.forEach(function (o) {
            o.style.display = 'flex';
            o.classList.remove('hpb-highlighted');
          });
          if (noMatch) noMatch.style.display = 'none';
          searchInput.focus();
        });

        // Keyboard navigation (Arrow keys, Enter, Escape)
        searchInput.addEventListener('keydown', function (e) {
          var visibleList = Array.prototype.slice.call(optElements).filter(function (o) {
            return o.style.display !== 'none';
          });

          if (e.key === 'ArrowDown') {
            e.preventDefault();
            if (visibleList.length === 0) return;
            var curIdx = visibleList.findIndex(function (o) { return o.classList.contains('hpb-highlighted'); });
            var nextIdx = curIdx + 1;
            if (nextIdx >= visibleList.length) nextIdx = 0;
            visibleList.forEach(function (o) { o.classList.remove('hpb-highlighted'); });
            visibleList[nextIdx].classList.add('hpb-highlighted');
            visibleList[nextIdx].scrollIntoView({ block: 'nearest' });
          } else if (e.key === 'ArrowUp') {
            e.preventDefault();
            if (visibleList.length === 0) return;
            var curIdx = visibleList.findIndex(function (o) { return o.classList.contains('hpb-highlighted'); });
            var prevIdx = curIdx - 1;
            if (prevIdx < 0) prevIdx = visibleList.length - 1;
            visibleList.forEach(function (o) { o.classList.remove('hpb-highlighted'); });
            visibleList[prevIdx].classList.add('hpb-highlighted');
            visibleList[prevIdx].scrollIntoView({ block: 'nearest' });
          } else if (e.key === 'Enter') {
            e.preventDefault();
            var highlighted = visibleList.find(function (o) { return o.classList.contains('hpb-highlighted'); });
            if (highlighted) {
              selectStall(highlighted.dataset.stall);
            } else if (visibleList.length > 0) {
              selectStall(visibleList[0].dataset.stall);
            }
          } else if (e.key === 'Escape') {
            e.preventDefault();
            closeMenu();
            triggerBtn.focus();
          }
        });

        optElements.forEach(function (opt) {
          opt.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            selectStall(opt.dataset.stall);
          });
        });
      }

      // Remove button
      var btnRemove = card.querySelector('[data-action="remove-item"]');
      if (btnRemove) {
        btnRemove.addEventListener('click', function () {
          if (state.items.length <= 1) return;
          state.items = state.items.filter(function (i) { return i.id !== id; });
          renderItemRows();
        });
      }
    });
  }

  // =========================================================================
  // 7. LIVE RECEIPT & STALL-WISE SUMMARY (RIGHT COLUMN)
  // =========================================================================
  function updateLiveReceipt() {
    var totals = getCalculatedTotals();
    var stallGroups = getStallGroups();

    // Bill metadata
    if (el.billNoDisplay) el.billNoDisplay.textContent = billCopyDisplay(state.items, '--');
    if (el.timeDisplay) el.timeDisplay.textContent = formatReceiptDate(state.timestamp);

    // Customer info
    if (el.recCustName) {
      el.recCustName.textContent = state.customer.name ? state.customer.name : 'Customer Not Entered';
    }
    if (el.recCustPhone) {
      el.recCustPhone.textContent = state.customer.phone ? '+91 ' + state.customer.phone : 'Phone not entered';
    }

    // Stall-wise Breakdown List (Client Spec Page 5, 7, 14)
    if (el.recStallsList) {
      el.recStallsList.innerHTML = '';
      if (stallGroups.length === 0 || totals.payable === 0) {
        el.recStallsList.innerHTML = '<span style="font-size:0.8rem; color:var(--hpd-ink-muted);">Select stalls &amp; enter prices to view vendor split</span>';
      } else {
        stallGroups.forEach(function (g) {
          var row = document.createElement('div');
          row.className = 'hpb-rec-stall-group-row';
          row.innerHTML = [
            '<div>',
            '  <strong>Stall #' + g.stallNo + ' · ' + escapeHtml(g.vendorName) + '</strong>',
            '  <small style="color:var(--hpd-ink-muted); display:block;">' + g.itemsCount + ' item' + (g.itemsCount > 1 ? 's' : '') + '</small>',
            '</div>',
            '<span class="subtotal">' + formatINR(g.subtotal) + '</span>'
          ].join('');
          el.recStallsList.appendChild(row);
        });
      }
    }

    // Line items list preview
    if (el.recItemsList) {
      el.recItemsList.innerHTML = '';
      state.items.forEach(function (item) {
        var price = parseFloat(item.eventPrice) || 0;
        var mrp = price * 2;
        var row = document.createElement('div');
        row.className = 'hpb-rec-item-row';
        row.innerHTML = [
          '<div class="hpb-rec-item-left">',
          '  <span class="hpb-rec-item-name">' + escapeHtml(item.title || 'Untitled Item') + '</span>',
          '  <span class="hpb-rec-item-sku">Stall #' + item.stallNo + ' · Bill #' + escapeHtml(item.billCopyNo || '--') + ' · ' + escapeHtml(item.sku) + '</span>',
          '</div>',
          '<div class="hpb-rec-item-right">',
          '  <span class="hpb-rec-item-price">' + formatINR(price) + '</span>',
          '  <span class="hpb-rec-item-mrp">' + formatINR(mrp) + '</span>',
          '</div>'
        ].join('');
        el.recItemsList.appendChild(row);
      });
    }

    // Math Totals
    if (el.recTotalMrp) el.recTotalMrp.textContent = formatINR(totals.totalMrp);
    if (el.recTotalSavings) el.recTotalSavings.textContent = '-' + formatINR(totals.totalSavings) + ' (50% OFF)';
    if (el.recNetPayable) el.recNetPayable.textContent = formatINR(totals.payable);
    if (el.btnPayRzpVal) el.btnPayRzpVal.textContent = formatINR(totals.payable) + ' ➔';

    // Mobile Dock live sync
    if (el.mobNetPayable) el.mobNetPayable.textContent = formatINR(totals.payable);
    if (el.mobSavings) {
      el.mobSavings.textContent = totals.totalSavings > 0 ? ('Save ' + formatINR(totals.totalSavings) + ' (50% OFF)') : '50% OFF';
    }

    // Cash Calculator update & Quick Exact Chip label
    if (el.cashChipExact) {
      el.cashChipExact.textContent = 'Exact (' + formatINR(totals.payable) + ')';
    }
    if (el.cashChangeDisplay) {
      el.cashChangeDisplay.textContent = formatINR(totals.changeToReturn);
    }

    // Auto-sync cash input if empty or exact amount was active
    if (state.paymentMode === 'cash' && el.inputCashTendered) {
      var curVal = parseFloat(el.inputCashTendered.value);
      if (isNaN(curVal) || curVal <= 0) {
        if (!el.inputCashTendered.matches(':focus')) {
          el.inputCashTendered.value = totals.payable > 0 ? totals.payable : '';
          state.cashTendered = totals.payable;
          if (el.cashChangeDisplay) el.cashChangeDisplay.textContent = '₹0';
        }
      }
    }
  }

  // =========================================================================
  // 8. ADD ITEM HANDLER
  // =========================================================================
  function handleAddItem() {
    // Default to last selected stall or first stall in STALL_MASTER
    var defaultStallNo = STALL_MASTER.length > 0 ? STALL_MASTER[0].stallNo : '01';
    var lastStall = state.items.length > 0 ? state.items[state.items.length - 1].stallNo : defaultStallNo;
    var sInfo = getStallInfo(lastStall);

    var countForStall = 0;
    state.items.forEach(function (it) {
      if (String(it.stallNo).trim() === String(lastStall).trim()) countForStall++;
    });
    var baseCount = getStallBaseCount(lastStall);
    var nextCount = baseCount + countForStall + 1;

    var newItem = {
      id: uid(),
      stallNo: lastStall,
      vendorName: sInfo.vendorName,
      billCopyNo: '',
      title: generateAutoProductTitle(sInfo, nextCount),
      isCustomTitle: false,
      eventPrice: '',
      mrp: 0,
      sku: generateProductSku(sInfo.vendorName, lastStall, nextCount)
    };

    state.items.push(newItem);
    renderItemRows();

    // Auto-focus title in new card
    setTimeout(function () {
      var lastCard = el.itemsContainer.lastElementChild;
      if (lastCard) {
        var billInp = lastCard.querySelector('[data-field="billCopyNo"]');
        if (billInp) billInp.focus();
      }
    }, 50);
  }

  // =========================================================================
  // 9. RAZORPAY CHECKOUT WITH PRE-FILL (CLIENT SPEC SECTION 7)
  // =========================================================================
  function handleRazorpayCheckout(copyChecked) {
    if (!validateBill(false)) return;
    if (copyChecked !== true) return withBillCopyCheck(function () { handleRazorpayCheckout(true); });

    var totals = getCalculatedTotals();
    var cleanPhone = (state.customer.phone || '').replace(/\D/g, '').slice(-10);
    var custEmail = (state.customer.email || '').trim();
    if (!custEmail) {
      custEmail = cleanPhone ? (cleanPhone + '@halfpe.com') : 'advisor@halfpe.com';
    }

    var payableAmount = Math.round(totals.payable);

    // Save pending bill in LocalStorage for recovery & webhook match
    var pendingBill = {
      billNo: state.billNo,
      timestamp: new Date().toISOString(),
      terminal: state.terminal,
      customer: {
        name: state.customer.name,
        phone: cleanPhone,
        email: custEmail,
        address: state.customer.address,
        isHomeDelivery: state.customer.isHomeDelivery
      },
      items: itemsForOrder(),
      totals: totals,
      stallGroups: getStallGroups(),
      paymentMode: 'razorpay',
      createdAt: Date.now()
    };

    try {
      localStorage.setItem('hpb_pending_bill', JSON.stringify(pendingBill));
      localStorage.setItem('hpb_pending_bill_time', Date.now().toString());
    } catch (e) {
      console.warn('LocalStorage save failed:', e);
    }

    // Pre-filled Hosted Razorpay Payment Page URL
    var rzpPageUrl = (el.app && el.app.dataset.rzpPageUrl) ? el.app.dataset.rzpPageUrl.trim() : 'https://pages.razorpay.com/pl_TiDS0lNFRYCj14/view';
    if (!rzpPageUrl) {
      rzpPageUrl = 'https://pages.razorpay.com/pl_TiDS0lNFRYCj14/view';
    }

    var sep = rzpPageUrl.indexOf('?') === -1 ? '?' : '&';
    var queryParams = [
      'amount=' + encodeURIComponent(payableAmount),
      'email=' + encodeURIComponent(custEmail),
      'phone=' + encodeURIComponent(cleanPhone),
      'full_name=' + encodeURIComponent(state.customer.name)
    ].join('&');

    // Redirect to Razorpay prefilled page
    window.location.href = rzpPageUrl + sep + queryParams;
  }

  // =========================================================================
  // 10. CASH / COD RECORDING (CLIENT SPEC SECTION 7)
  // =========================================================================
  function handleCashPayment(copyChecked) {
    state.paymentMode = 'cash';
    var totals = getCalculatedTotals();
    var enteredCash = parseFloat(state.cashTendered);
    if (isNaN(enteredCash) || enteredCash <= 0 || enteredCash < totals.payable) {
      state.cashTendered = totals.payable;
      if (el.inputCashTendered) {
        el.inputCashTendered.value = totals.payable > 0 ? totals.payable : '';
      }
    }

    if (!validateBill(false)) return;
    if (copyChecked !== true) return withBillCopyCheck(function () { handleCashPayment(true); });

    var btn = el.btnCash;
    if (btn) {
      btn.dataset.origHtml = btn.innerHTML;
      btn.innerHTML = '<span style="display:inline-flex; align-items:center; gap:8px;"><span>⏳</span> Syncing with Shopify...</span>';
      btn.style.pointerEvents = 'none';
      btn.style.opacity = '0.75';
    }

    completePayment({
      paymentId: 'CASH_' + Math.floor(100000 + Math.random() * 900000),
      method: 'Cash on Delivery (COD) · Counter POS',
      status: 'PAID'
    });

    setTimeout(function () {
      if (btn && btn.dataset.origHtml) {
        btn.innerHTML = btn.dataset.origHtml;
        btn.style.pointerEvents = '';
        btn.style.opacity = '';
      }
    }, 1800);
  }

  // =========================================================================
  // 10.5 PINELABS POS RECORDING
  // =========================================================================
  function handlePinelabsPayment(copyChecked) {
    state.paymentMode = 'pinelabs';
    if (!validateBill(false)) return;
    if (copyChecked !== true) return withBillCopyCheck(function () { handlePinelabsPayment(true); });

    var btn = el.btnPinelabs;
    if (btn) {
      btn.dataset.origHtml = btn.innerHTML;
      btn.innerHTML = '<span style="display:inline-flex; align-items:center; gap:8px;"><span>⏳</span> Processing Pinelabs POS...</span>';
      btn.style.pointerEvents = 'none';
      btn.style.opacity = '0.75';
    }

    var pinelabsTxnId = 'PL_' + Date.now().toString().slice(-6) + '_' + Math.floor(100 + Math.random() * 900);
    completePayment({
      paymentId: pinelabsTxnId,
      method: 'Pinelabs POS Terminal',
      status: 'PAID'
    });

    setTimeout(function () {
      if (btn && btn.dataset.origHtml) {
        btn.innerHTML = btn.dataset.origHtml;
        btn.style.pointerEvents = '';
        btn.style.opacity = '';
      }
    }, 1800);
  }

  // =========================================================================
  // 11. PAYMENT COMPLETION & STREAMLINED CONFIRMATION MODAL
  // =========================================================================
  function itemsForOrder() {
    return JSON.parse(JSON.stringify(state.items)).map(function (it) {
      it.quantity = Number(it.quantity) >= 1 ? Number(it.quantity) : 1;
      return it;
    });
  }

  function completePayment(payInfo) {
    var totals = getCalculatedTotals();
    var stallGroups = getStallGroups();

    state.lastPaidBill = {
      billNo: state.billNo,
      timestamp: new Date(),
      terminal: state.terminal,
      customer: JSON.parse(JSON.stringify(state.customer)),
      items: itemsForOrder(),
      totals: totals,
      stallGroups: stallGroups,
      payment: payInfo
    };

    // Increment persistent sequence counts for all billed stalls
    incrementStallCountsForBill(state.items);

    // Render Thermal / Official GST Tax Invoice background
    renderInvoicePaper(state.lastPaidBill);

    // Populate Streamlined Confirmation Modal (Green Tick & Essential Details Only)
    var bNoEl = document.getElementById('confModalBillNo');
    if (bNoEl) bNoEl.textContent = billCopyDisplay(state.lastPaidBill.items, state.lastPaidBill.billNo);
    var amtEl = document.getElementById('confModalAmount');
    if (amtEl) amtEl.textContent = '₹' + Number(totals.payable).toLocaleString('en-IN');
    var payEl = document.getElementById('confModalPayMethod');
    if (payEl) payEl.textContent = payInfo.method || 'Cash / COD';
    var custEl = document.getElementById('confModalCustomer');
    if (custEl) custEl.textContent = (state.customer.name || 'Customer') + ' (' + (state.customer.phone || '-') + ')';
    var timeEl = document.getElementById('confModalTime');
    if (timeEl) timeEl.textContent = new Date().toLocaleString('en-IN', { timeZone: 'Asia/Kolkata', dateStyle: 'medium', timeStyle: 'short' });

    // Open Success Modal with Flex centering
    if (el.modal) {
      el.modal.classList.add('is-open');
      el.modal.style.display = 'flex';
    }

    // Save in LocalStorage audit log
    try {
      var history = JSON.parse(localStorage.getItem('hpb_bills_audit') || '[]');
      history.unshift(state.lastPaidBill);
      if (history.length > 100) history.pop();
      localStorage.setItem('hpb_bills_audit', JSON.stringify(history));
    } catch (e) { }

    // Dispatch Order to Backend Webhook & Shopify Cart Note
    dispatchOrderBackend(state.lastPaidBill);

    // Reset billing form behind modal for NEXT customer!
    resetBillForm({ preserveModal: true });
  }

  // Dispatch order to Webhook & Shopify
  function dispatchOrderBackend(orderData) {
    var webhookUrl = (el.app && el.app.dataset.orderWebhook) ? el.app.dataset.orderWebhook.trim() : '';
    if (!webhookUrl) {
      webhookUrl = 'https://halfpe-expo-billing-backend-production.up.railway.app/api/create-order';
    }

    var numEl = document.getElementById('hpb-inv-shopify-num');
    if (numEl) {
      numEl.textContent = '⏳ Recording Order Internally...';
      numEl.style.color = '#D99B00';
    }

    var cleanCust = JSON.parse(JSON.stringify(orderData.customer || {}));
    var rawCustName = (cleanCust.name || '').trim();
    if (!rawCustName) {
      console.error('[Billing] Cannot record order without customer name.');
      return;
    }
    if (rawCustName.indexOf(' ') === -1) {
      cleanCust.name = rawCustName + ' .';
    } else {
      cleanCust.name = rawCustName;
    }

    try {
      fetch(webhookUrl, {
        method: 'POST',
        mode: 'cors',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          event: 'halfpe.expo.order_created',
          billNo: orderData.billNo,
          bill_number: orderData.billNo,
          clientOrderRef: orderData.billNo,
          timestamp: orderData.timestamp,
          cityId: CURRENT_CITY_ID,
          city: CURRENT_CITY_ID,
          terminal: orderData.terminal,
          customer: cleanCust,
          items: orderData.items,
          stallGroups: orderData.stallGroups,
          stall_groups: orderData.stallGroups,
          totals: orderData.totals,
          payment: orderData.payment,
          tags: ['HPD', CURRENT_CITY_ID + '-Event', (orderData.payment.method && orderData.payment.method.indexOf('Cash') !== -1) ? 'Pay-Cash' : 'Pay-Razorpay']
        })
      })
      .then(function (res) { return res.json(); })
      .then(function (resData) {
        if (numEl) {
          if (resData && (resData.shopifyOrderNumber || resData.orderName)) {
            var orderNum = resData.shopifyOrderNumber || resData.orderName;
            orderData.shopifyOrderNumber = orderNum;
            numEl.textContent = orderNum + (resData.isMock ? ' (Sandbox)' : ' ✓');
            numEl.style.color = '#008060';
            console.log('[HALFPE BACKEND] Shopify Order synced:', orderNum);
          } else if (resData && (resData.internalOrderRecorded || resData.success)) {
            numEl.textContent = 'Recorded Internally (Awaiting Approval) ✓';
            numEl.style.color = '#008060';
            console.log('[HALFPE BACKEND] Order staged internally for Super Admin approval:', resData.billNo);
          } else {
            console.error('[HALFPE BACKEND] Sync Error:', resData);
            numEl.textContent = 'Sync Notice: ' + (resData && (resData.error || resData.message) ? (resData.error || resData.message) : 'Check Dashboard');
            numEl.style.color = '#C4122F';
          }
        }
      })
      .catch(function (err) {
        console.warn('Webhook / Backend order dispatch error:', err);
      });
    } catch (e) {
      if (numEl) {
        numEl.textContent = 'Saved Offline (POS Audit)';
        numEl.style.color = '#777';
      }
    }

    // Direct resilient dual-dispatch to both Render & Railway Dashboards
    try {
      var dashPayload = JSON.stringify({
        cityId: CURRENT_CITY_ID,
        city: CURRENT_CITY_ID,
        billNo: orderData.billNo,
        clientOrderRef: orderData.billNo,
        customer: cleanCust,
        items: orderData.items,
        stallGroups: orderData.stallGroups,
        totals: orderData.totals,
        payment: orderData.payment,
        terminal: orderData.terminal,
        source: 'POS Billing Desk (Dual-Sync)',
        timestamp: orderData.timestamp || new Date().toISOString()
      });

      var dashUrls = [
        'https://halfpe-settlement.onrender.com/api/orders/record',
        'https://halfpe-settlement-dashboard-production.up.railway.app/api/orders/record'
      ];
      dashUrls.forEach(function (dUrl) {
        try {
          fetch(dUrl, {
            method: 'POST',
            mode: 'cors',
            headers: { 'Content-Type': 'application/json' },
            body: dashPayload
          }).catch(function () { });
        } catch (e) { }
      });
    } catch (e) { }

    // Shopify Storefront Cart Note & Attributes sync
    try {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          note: CITY_LABEL + ' Expo Bill #' + orderData.billNo + ' | Stalls: ' + orderData.stallGroups.map(function (g) { return '#' + g.stallNo; }).join(', ') + ' | Paid: ' + formatINR(orderData.totals.payable) + ' via ' + orderData.payment.method + ' [' + orderData.payment.paymentId + ']',
          attributes: {
            'Expo_Bill_No': orderData.billNo,
            'Expo_Stalls': orderData.stallGroups.map(function (g) { return '#' + g.stallNo + ' (' + g.vendorName + ')'; }).join('; '),
            'Payment_Status': 'PAID',
            'Payment_Method': orderData.payment.method,
            'Payment_Ref': orderData.payment.paymentId,
            'Customer_Name': orderData.customer.name,
            'Customer_Phone': orderData.customer.phone
          }
        })
      }).catch(function () { });
    } catch (e) { }
  }

  // Styles for the printed slip. The slip prints from its own frame, so nothing on the page
  // (hidden containers, the open popup, page height) can turn the printout blank.
  var SLIP_PRINT_CSS = [
    '@page { margin: 6mm; }',
    'html { font-size: 13px; }',
    'body { margin: 0; color: #111; font-family: "Courier New", ui-monospace, monospace; line-height: 1.45; }',
    '.hpb-slip { width: 76mm; max-width: 100%; margin: 0 auto; }',
    '.hpb-inv-center { text-align: center; }',
    '.hpb-inv-divider { border-bottom: 1px dashed #777; margin: 8px 0; }',
    '.hpb-inv-row { display: flex; justify-content: space-between; gap: 8px; margin-bottom: 4px; }',
    '.hpb-inv-row > *:last-child { text-align: right; }',
    '.hpb-inv-total-row { display: flex; justify-content: space-between; font-weight: 900; font-size: 0.95rem; margin-top: 6px; padding-top: 6px; border-top: 1.5px solid #111; }',
    '.hpb-inv-table { width: 100%; border-collapse: collapse; margin: 6px 0; font-size: 0.8rem; }',
    '.hpb-inv-table th { border-bottom: 1px solid #333; text-align: left; padding: 3px 0; font-size: 0.72rem; }',
    '.hpb-inv-table td { padding: 4px 0; vertical-align: top; }'
  ].join('\n');

  function printInvoiceSlip() {
    if (el.invoicePaperRoot && !el.invoicePaperRoot.innerHTML.trim() && state.lastPaidBill) {
      renderInvoicePaper(state.lastPaidBill);
    }
    var slipHtml = el.invoicePaperRoot ? el.invoicePaperRoot.innerHTML.trim() : '';
    if (!slipHtml) {
      alert('There is no completed bill to print yet.');
      return;
    }
    var title = 'HalfPe Bill ' + (state.lastPaidBill ? billCopyDisplay(state.lastPaidBill.items, state.lastPaidBill.billNo) : '');
    var old = document.getElementById('hpb-print-frame');
    if (old && old.parentNode) old.parentNode.removeChild(old);
    var frame = document.createElement('iframe');
    frame.id = 'hpb-print-frame';
    frame.setAttribute('aria-hidden', 'true');
    frame.setAttribute('tabindex', '-1');
    frame.style.cssText = 'position:fixed; right:0; bottom:0; width:0; height:0; border:0; opacity:0; pointer-events:none;';
    document.body.appendChild(frame);
    var win = frame.contentWindow;
    var doc = win.document;
    doc.open();
    doc.write('<!doctype html><html><head><meta charset="utf-8"><title>' + escapeHtml(title) + '</title><style>' + SLIP_PRINT_CSS + '</style></head><body><div class="hpb-slip">' + slipHtml + '</div></body></html>');
    doc.close();
    setTimeout(function () {
      try {
        win.focus();
        win.print();
      } catch (e) {
        window.print();
      }
    }, 250);
  }

  // Render Printable Tax Invoice
  function renderInvoicePaper(data) {
    if (!el.invoicePaperRoot) return;

    var rowsHtml = data.items.map(function (item, idx) {
      var price = parseFloat(item.eventPrice) || 0;
      return [
        '<tr>',
        '  <td style="padding:4px 0;">' + (idx + 1) + '. ' + escapeHtml(item.title) + '<br><small style="color:#555;">Stall #' + item.stallNo + ' (' + escapeHtml(item.vendorName) + ') · Bill Copy #' + escapeHtml(item.billCopyNo) + '<br>SKU: ' + escapeHtml(item.sku) + '</small></td>',
        '  <td style="text-align:right; text-decoration:line-through; color:#777; padding:4px 0;">' + formatINR(item.mrp) + '</td>',
        '  <td style="text-align:right; font-weight:700; padding:4px 0;">' + formatINR(price) + '</td>',
        '</tr>'
      ].join('');
    }).join('');

    var stallBreakdownHtml = data.stallGroups.map(function (g) {
      return '<div class="hpb-inv-row"><span>Stall #' + g.stallNo + ' (' + escapeHtml(g.vendorName) + ' · ' + g.itemsCount + ' items):</span><strong>' + formatINR(g.subtotal) + '</strong></div>';
    }).join('');

    var invTitle = (el.app && el.app.dataset.invTitle) || 'HALF PRICE DAYS';
    var invSub = IS_VIJ
      ? ((el.app && el.app.dataset.invSub) || 'VIJAYAWADA RETAIL EXPO · SVN CONVENTIONS')
      : ((CITY_INFO && CITY_INFO.name ? CITY_INFO.name + ' · ' : '') + cityVenueAddress()).toUpperCase();
    var invCounter = (el.app && el.app.dataset.invCounterInfo) || 'Central Billing Counter · Official GST Tax Slip';

    el.invoicePaperRoot.innerHTML = [
      '<div class="hpb-inv-center">',
      '  <h3 style="margin:0; font-size:1.15rem; font-weight:900; letter-spacing:0.02em;">' + escapeHtml(invTitle) + '</h3>',
      '  <div style="font-size:0.8rem; font-weight:700;">' + escapeHtml(invSub) + '</div>',
      '  <div style="font-size:0.75rem; color:#555;">' + escapeHtml(invCounter) + '</div>',
      '</div>',
      '<div class="hpb-inv-divider"></div>',
      '<div class="hpb-inv-row"><span>Bill No:</span><strong>' + escapeHtml(billCopyDisplay(data.items, data.billNo)) + '</strong></div>',
      '<div class="hpb-inv-row"><span>Date & Time:</span><span>' + formatReceiptDate(data.timestamp) + '</span></div>',
      '<div class="hpb-inv-row"><span>Terminal:</span><span>' + escapeHtml(data.terminal) + '</span></div>',
      '<div class="hpb-inv-row"><span>Customer:</span><span>' + escapeHtml(data.customer.name) + ' (' + escapeHtml(data.customer.phone) + ')</span></div>',
      '<div class="hpb-inv-row"><span>Address:</span><span style="font-size:0.75rem;">' + escapeHtml(data.customer.address) + '</span></div>',
      '<div class="hpb-inv-row"><span>Payment Ref:</span><span style="color:#0E8A4D; font-weight:700;">' + data.payment.paymentId + '</span></div>',
      '<div class="hpb-inv-row" id="hpb-inv-shopify-row"><span>Shopify Order:</span><strong id="hpb-inv-shopify-num" style="color:#008060;">' + (data.shopifyOrderNumber || 'Syncing to Shopify...') + '</strong></div>',
      '<div class="hpb-inv-divider"></div>',
      '<div style="font-size:0.78rem; font-weight:700; margin-bottom:4px;">MULTI-STALL VENDOR BREAKDOWN:</div>',
      stallBreakdownHtml,
      '<div class="hpb-inv-divider"></div>',
      '<table class="hpb-inv-table">',
      '  <thead>',
      '    <tr>',
      '      <th style="width:60%;">Item &amp; Stall</th>',
      '      <th style="text-align:right;">MRP</th>',
      '      <th style="text-align:right;">Event Price</th>',
      '    </tr>',
      '  </thead>',
      '  <tbody>' + rowsHtml + '</tbody>',
      '</table>',
      '<div class="hpb-inv-divider"></div>',
      '<div class="hpb-inv-row"><span>Total MRP:</span><span style="text-decoration:line-through;">' + formatINR(data.totals.totalMrp) + '</span></div>',
      '<div class="hpb-inv-row" style="color:#0E8A4D; font-weight:700;"><span>HalfPe Savings:</span><span>-' + formatINR(data.totals.totalSavings) + ' (50% OFF)</span></div>',
      '<div class="hpb-inv-total-row"><span>NET AMOUNT PAID:</span><span>' + formatINR(data.totals.payable) + '</span></div>',
      '<div class="hpb-inv-center" style="margin-top:10px; font-size:0.75rem; color:#444;">',
      '  <div style="font-weight:700; color:#0E8A4D; border:1px solid #0E8A4D; display:inline-block; padding:2px 8px; border-radius:4px; margin-bottom:6px;">✓ VERIFIED ' + data.payment.status + '</div>',
      '  <div>' + escapeHtml((el.app && el.app.dataset.invFooter1) || 'Thank you for shopping at Half Price Days!') + '</div>',
      '  <div>' + escapeHtml((el.app && el.app.dataset.invFooter2) || 'All items sold at Minimum 50% OFF. Visit HalfPe.com') + '</div>',
      '</div>'
    ].join('');

    // Configure WhatsApp Button
    if (el.btnWhatsappShare) {
      var waMsg = [
        '🎉 *Half Price Days ' + CITY_LABEL + ' — Official Invoice*',
        IS_VIJ ? 'SVN Conventions, Poranki, Vijayawada' : cityVenueAddress(),
        '',
        '📄 *Bill No:* ' + billCopyDisplay(data.items, data.billNo),
        '👤 *Customer:* ' + data.customer.name,
        '🏬 *Stalls:* ' + data.stallGroups.map(function (g) { return '#' + g.stallNo + ' (' + g.vendorName + ')'; }).join(', '),
        '🛍️ *Items:* ' + data.items.map(function (i) { return i.title + ' (₹' + i.eventPrice + ')'; }).join(', '),
        '💰 *Total MRP:* ' + formatINR(data.totals.totalMrp),
        '🔥 *Your Savings:* ' + formatINR(data.totals.totalSavings) + ' (50% OFF)',
        '✅ *Amount Paid:* ' + formatINR(data.totals.payable) + ' via ' + data.payment.method,
        '🔖 *Payment Ref:* ' + data.payment.paymentId,
        '',
        'Thank you for shopping with us at ' + (IS_VIJ ? 'SVN Conventions' : ((CITY_INFO && CITY_INFO.venue) || CITY_LABEL)) + '!'
      ].join('\n');

      el.btnWhatsappShare.href = 'https://wa.me/91' + data.customer.phone.replace(/\D/g, '') + '?text=' + encodeURIComponent(waMsg);
    }
  }

  // =========================================================================
  // 12. RESET FORM FOR NEXT CUSTOMER
  // =========================================================================
  function resetBillForm(options) {
    options = options || {};
    state.billNo = generateBillNo();
    state.timestamp = new Date();
    state.customer = {
      name: '',
      phone: '',
      email: '',
      address: defaultVenueAddress,
      isHomeDelivery: false
    };
    state.cashTendered = 0;
    var firstStallNo = STALL_MASTER.length > 0 ? STALL_MASTER[0].stallNo : '01';
    var firstStallInfo = getStallInfo(firstStallNo);
    state.items = [
      {
        id: uid(),
        stallNo: firstStallNo,
        vendorName: firstStallInfo.vendorName,
        billCopyNo: '',
        title: generateAutoProductTitle(firstStallInfo, 1),
        isCustomTitle: false,
        eventPrice: '',
        mrp: 0,
        sku: generateProductSku(firstStallInfo.vendorName, firstStallNo, 1)
      }
    ];

    if (el.inputCustName) el.inputCustName.value = '';
    if (el.inputCustPhone) el.inputCustPhone.value = '';
    if (el.inputCustEmail) el.inputCustEmail.value = '';
    if (el.inputCustAddress) {
      el.inputCustAddress.value = defaultVenueAddress;
      el.inputCustAddress.readOnly = true;
      el.inputCustAddress.classList.remove('is-editable');
    }
    if (el.toggleDelivery) el.toggleDelivery.checked = false;
    if (el.inputCashTendered) el.inputCashTendered.value = '';
    if (el.cashChangeDisplay) el.cashChangeDisplay.textContent = '₹0';

    renderItemRows();
    updateLiveReceipt();
    updateButtonStates();

    if (!options.preserveModal) {
      if (el.modal) el.modal.classList.remove('is-open');
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }

  // =========================================================================
  // 13. RETURN CALLBACK & PENDING BANNER RECOVERY
  // =========================================================================
  function checkForPaymentCallback() {
    var urlParams = new URLSearchParams(window.location.search);
    var rzpPaymentId = urlParams.get('razorpay_payment_id') ||
      urlParams.get('payment_id') ||
      urlParams.get('razorpay_payment_link_id') ||
      urlParams.get('p_id');
    var paymentStatus = (urlParams.get('payment_status') || urlParams.get('status') || '').toLowerCase();

    var isSuccess = (paymentStatus === 'success' || paymentStatus === 'paid') || !!rzpPaymentId;

    var pendingBillRaw = null;
    try {
      pendingBillRaw = localStorage.getItem('hpb_pending_bill');
    } catch (e) { }

    if (isSuccess && pendingBillRaw) {
      try {
        var billData = JSON.parse(pendingBillRaw);
        var paymentRef = rzpPaymentId || ('RZP_PAID_' + Math.floor(100000 + Math.random() * 900000));

        // Clean query parameters from address bar
        var cleanUrl = window.location.pathname;
        if (urlParams.has('pb')) {
          cleanUrl += '?pb=' + urlParams.get('pb');
        }
        window.history.replaceState({}, document.title, cleanUrl);

        localStorage.removeItem('hpb_pending_bill');
        localStorage.removeItem('hpb_pending_bill_time');

        state.billNo = billData.billNo;
        state.timestamp = new Date(billData.timestamp || Date.now());
        state.terminal = billData.terminal || state.terminal;
        state.customer = billData.customer;
        state.items = billData.items;

        completePayment({
          paymentId: paymentRef,
          orderId: billData.billNo,
          method: 'Razorpay Online',
          status: 'PAID'
        });

        if (el.pendingBanner) el.pendingBanner.style.display = 'none';

      } catch (err) {
        console.error('Error restoring pending bill:', err);
      }
    } else if (pendingBillRaw) {
      renderPendingBillBanner(pendingBillRaw);
    }
  }

  function renderPendingBillBanner(pendingBillRaw) {
    if (!el.pendingBanner) return;
    try {
      var billData = JSON.parse(pendingBillRaw);
      var savedTime = parseInt(localStorage.getItem('hpb_pending_bill_time') || '0', 10);
      var ageMinutes = (Date.now() - savedTime) / (1000 * 60);

      if (ageMinutes < 60 && billData && billData.customer && billData.customer.name) {
        var custName = escapeHtml(billData.customer.name || 'Customer');
        var custPhone = escapeHtml(billData.customer.phone || '');
        var amount = formatINR(billData.totals ? billData.totals.payable : 0);

        el.pendingBanner.innerHTML = [
          '<div class="hpb-pending-info">',
          '  <div class="hpb-pending-icon">⏳</div>',
          '  <div class="hpb-pending-text">',
          '    <strong>Recent Payment in Progress:</strong> Bill for <b>' + custName + '</b> (' + custPhone + ') of <b>' + amount + '</b> was redirected to Razorpay.',
          '  </div>',
          '</div>',
          '<div class="hpb-pending-actions">',
          '  <button type="button" class="hpb-btn-pending-confirm" id="hpb-btn-resolve-paid" style="background:#0E8A4D; color:#fff; font-weight:800; padding:6px 12px; border-radius:6px; cursor:pointer;">✓ Customer Paid on Razorpay — Generate Invoice &amp; Sync Order</button>',
          '  <button type="button" class="hpb-btn-pending-discard" id="hpb-btn-resolve-discard" style="background:#eee; color:#333; padding:6px 10px; border-radius:6px; cursor:pointer;">✕ Discard</button>',
          '</div>'
        ].join('');

        el.pendingBanner.style.display = 'flex';

        var btnConfirm = document.getElementById('hpb-btn-resolve-paid');
        if (btnConfirm) {
          btnConfirm.addEventListener('click', function () {
            var pId = 'RZP_VERIFIED_' + Math.floor(100000 + Math.random() * 900000);

            try {
              localStorage.removeItem('hpb_pending_bill');
              localStorage.removeItem('hpb_pending_bill_time');
            } catch (e) { }
            el.pendingBanner.style.display = 'none';

            state.billNo = billData.billNo;
            state.timestamp = new Date();
            state.customer = billData.customer;
            state.items = billData.items;

            completePayment({
              paymentId: pId,
              orderId: billData.billNo,
              method: 'Razorpay Online',
              status: 'PAID'
            });
          });
        }

        var btnDiscard = document.getElementById('hpb-btn-resolve-discard');
        if (btnDiscard) {
          btnDiscard.addEventListener('click', function () {
            if (confirm('Discard this pending payment session?')) {
              localStorage.removeItem('hpb_pending_bill');
              localStorage.removeItem('hpb_pending_bill_time');
              el.pendingBanner.style.display = 'none';
            }
          });
        }
      } else {
        localStorage.removeItem('hpb_pending_bill');
        localStorage.removeItem('hpb_pending_bill_time');
        el.pendingBanner.style.display = 'none';
      }
    } catch (e) {
      el.pendingBanner.style.display = 'none';
    }
  }

  // =========================================================================
  // 14. GLOBAL EVENT LISTENERS
  // =========================================================================
  function bindGlobalEvents() {
    // Customer Name
    if (el.inputCustName) {
      el.inputCustName.addEventListener('input', function () {
        state.customer.name = el.inputCustName.value;
        updateLiveReceipt();
        updateButtonStates();
      });
    }

    // Customer Phone
    if (el.inputCustPhone) {
      el.inputCustPhone.addEventListener('input', function () {
        state.customer.phone = el.inputCustPhone.value;
        updateLiveReceipt();
        updateButtonStates();
      });
    }

    // Customer Email
    if (el.inputCustEmail) {
      el.inputCustEmail.addEventListener('input', function () {
        state.customer.email = el.inputCustEmail.value;
        updateButtonStates();
      });
    }

    // Home Delivery Checkbox Toggle
    if (el.toggleDelivery) {
      el.toggleDelivery.addEventListener('change', function () {
        state.customer.isHomeDelivery = el.toggleDelivery.checked;
        if (el.inputCustAddress) {
          if (el.toggleDelivery.checked) {
            el.inputCustAddress.readOnly = false;
            el.inputCustAddress.classList.add('is-editable');
            el.inputCustAddress.placeholder = 'Enter customer Home Delivery landmark, flat no., street, city...';
            el.inputCustAddress.value = '';
            el.inputCustAddress.focus();
          } else {
            el.inputCustAddress.readOnly = true;
            el.inputCustAddress.classList.remove('is-editable');
            el.inputCustAddress.value = defaultVenueAddress;
            state.customer.address = defaultVenueAddress;
          }
        }
      });
    }

    if (el.inputCustAddress) {
      el.inputCustAddress.addEventListener('input', function () {
        state.customer.address = el.inputCustAddress.value;
      });
    }

    // Add Product Button
    if (el.btnAddItem) {
      el.btnAddItem.addEventListener('click', handleAddItem);
    }

    // Payment Mode Switching
    if (el.paymodeCards) {
      el.paymodeCards.forEach(function (card) {
        card.addEventListener('click', function () {
          el.paymodeCards.forEach(function (c) { c.classList.remove('active'); });
          card.classList.add('active');
          state.paymentMode = card.dataset.paymode;

          if (state.paymentMode === 'cash') {
            if (el.cashCalculatorBox) el.cashCalculatorBox.style.display = 'block';
            var curTotals = getCalculatedTotals();
            if (curTotals.payable > 0 && (!state.cashTendered || state.cashTendered < curTotals.payable)) {
              state.cashTendered = curTotals.payable;
              if (el.inputCashTendered) el.inputCashTendered.value = curTotals.payable;
              if (el.cashChangeDisplay) el.cashChangeDisplay.textContent = '₹0';
            }
          } else {
            if (el.cashCalculatorBox) el.cashCalculatorBox.style.display = 'none';
          }
          if (el.btnPayRazorpay) el.btnPayRazorpay.style.display = 'flex';
          if (el.btnCash) el.btnCash.style.display = 'flex';

          updateButtonStates();
        });
      });
    }

    // Cash Tendered input
    if (el.inputCashTendered) {
      el.inputCashTendered.addEventListener('input', function () {
        var rawVal = parseFloat(el.inputCashTendered.value);
        state.cashTendered = (!isNaN(rawVal) && rawVal > 0) ? rawVal : 0;
        updateLiveReceipt();
        updateButtonStates();
      });

      el.inputCashTendered.addEventListener('blur', function () {
        var totals = getCalculatedTotals();
        var rawVal = parseFloat(el.inputCashTendered.value);
        if (isNaN(rawVal) || rawVal <= 0 || rawVal < totals.payable) {
          state.cashTendered = totals.payable;
          el.inputCashTendered.value = totals.payable > 0 ? totals.payable : '';
          updateLiveReceipt();
        }
      });
    }

    // Quick Cash Denomination Chips
    if (el.cashChips) {
      el.cashChips.forEach(function (chipBtn) {
        chipBtn.addEventListener('click', function (e) {
          e.preventDefault();
          var chipVal = chipBtn.dataset.chip;
          var totals = getCalculatedTotals();
          var newAmount = totals.payable;

          if (chipVal === 'exact') {
            newAmount = totals.payable;
          } else {
            var parsed = parseFloat(chipVal);
            if (!isNaN(parsed) && parsed > 0) {
              newAmount = parsed;
            }
          }

          state.cashTendered = newAmount;
          if (el.inputCashTendered) el.inputCashTendered.value = newAmount;
          updateLiveReceipt();
          updateButtonStates();
        });
      });
    }

    // Razorpay Pay Online Button (Desktop & Mobile)
    if (el.btnPayRazorpay) {
      el.btnPayRazorpay.addEventListener('click', handleRazorpayCheckout);
    }
    if (el.mobBtnRzp) {
      el.mobBtnRzp.addEventListener('click', handleRazorpayCheckout);
    }

    // Cash Record Button (Desktop & Mobile)
    if (el.btnCash) {
      el.btnCash.addEventListener('click', handleCashPayment);
    }
    if (el.mobBtnCash) {
      el.mobBtnCash.addEventListener('click', handleCashPayment);
    }

    // Pinelabs POS Button (Desktop & Mobile)
    if (el.btnPinelabs) {
      el.btnPinelabs.addEventListener('click', handlePinelabsPayment);
    }
    if (el.mobBtnPinelabs) {
      el.mobBtnPinelabs.addEventListener('click', handlePinelabsPayment);
    }

    // Reset Bill Button
    if (el.btnReset) {
      el.btnReset.addEventListener('click', function () {
        if (confirm('Start a fresh bill? Current entered data will be cleared.')) {
          resetBillForm();
        }
      });
    }

    // Modal Close
    if (el.modalClose) {
      el.modalClose.addEventListener('click', function () {
        if (el.modal) {
          el.modal.classList.remove('is-open');
          el.modal.style.display = 'none';
        }
      });
    }

    // Modal "Create New Bill" Button
    if (el.btnConfirmNewBill) {
      el.btnConfirmNewBill.addEventListener('click', function () {
        if (el.modal) {
          el.modal.classList.remove('is-open');
          el.modal.style.display = 'none';
        }
        resetBillForm();
      });
    }

    // Print Invoice Button
    if (el.btnPrintInvoice) {
      el.btnPrintInvoice.addEventListener('click', printInvoiceSlip);
    }

    // Dismiss open stall combobox menus on outside click
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.hpb-stall-combobox')) {
        document.querySelectorAll('.hpb-stall-menu').forEach(function (m) {
          m.style.display = 'none';
          var p = m.closest('.hpb-stall-combobox');
          if (p) {
            var btn = p.querySelector('.hpb-stall-trigger');
            if (btn) btn.classList.remove('hpb-is-open');
          }
        });
      }
    });
  }

  // =========================================================================
  // 15. INITIALIZATION
  // =========================================================================
  document.addEventListener('DOMContentLoaded', function () {
    if (initElements()) {
      loadStallMaster();
      applyCityHeader();
      fetchDynamicCityStalls();
      fetchBillSeries();
      renderItemRows();
      bindGlobalEvents();
      updateLiveReceipt();
      checkForPaymentCallback();
    }
  });

  // Shopify Theme Customizer Live Preview Listeners
  document.addEventListener('shopify:section:load', function () {
    if (initElements()) {
      loadStallMaster();
      renderItemRows();
      updateLiveReceipt();
    }
  });

  document.addEventListener('shopify:block:select', function () {
    if (initElements()) {
      loadStallMaster();
      renderItemRows();
      updateLiveReceipt();
    }
  });

  document.addEventListener('shopify:block:deselect', function () {
    if (initElements()) {
      loadStallMaster();
      renderItemRows();
      updateLiveReceipt();
    }
  });

})();
